(function () {
  'use strict';

  var CANVAS_W = 560;
  var CANVAS_H = 420;
  var HANDLE_R = 10;

  /* Résolution réelle de l'aperçu, en pixels physiques par unité de dessin.
     Tout le code raisonne en unités 560×420 ; seul le nombre de pixels du
     canvas change. Sans cela l'aperçu était dessiné en 560 px de large puis
     étiré par le CSS jusqu'à 720 px, sur un écran Retina qui en demande le
     double — soit 2,5 pixels d'écran pour 1 pixel dessiné, et un produit
     visiblement flou. Recalculé à chaque ouverture (voir applyCanvasResolution). */
  var PX = 1;

  /* Bibliothèque de polices : web-safe + Google Fonts (chargées à l'ouverture
     du configurateur, puis à la demande quand une police est choisie). */
  var FONTS = [
    { group: 'Manuscrites', items: [
      { name: 'Dancing Script', value: '"Dancing Script", cursive' },
      { name: 'Great Vibes', value: '"Great Vibes", cursive' },
      { name: 'Parisienne', value: '"Parisienne", cursive' },
      { name: 'Sacramento', value: '"Sacramento", cursive' },
      { name: 'Satisfy', value: '"Satisfy", cursive' },
      { name: 'Caveat', value: '"Caveat", cursive' },
      { name: 'Pacifico', value: '"Pacifico", cursive' },
    ]},
    { group: 'Élégantes', items: [
      { name: 'Playfair Display', value: '"Playfair Display", serif' },
      { name: 'Cormorant Garamond', value: '"Cormorant Garamond", serif' },
      { name: 'Cinzel', value: '"Cinzel", serif' },
      { name: 'EB Garamond', value: '"EB Garamond", serif' },
      { name: 'Georgia', value: 'Georgia, serif' },
      { name: 'Palatino', value: '"Palatino Linotype", "Book Antiqua", Palatino, serif' },
      { name: 'Times New Roman', value: '"Times New Roman", Times, serif' },
      { name: 'Garamond', value: 'Garamond, serif' },
    ]},
    { group: 'Modernes', items: [
      { name: 'Montserrat', value: '"Montserrat", sans-serif' },
      { name: 'Poppins', value: '"Poppins", sans-serif' },
      { name: 'Raleway', value: '"Raleway", sans-serif' },
      { name: 'Oswald', value: '"Oswald", sans-serif' },
      { name: 'Bebas Neue', value: '"Bebas Neue", sans-serif' },
      { name: 'Arial', value: 'Arial, sans-serif' },
      { name: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
      { name: 'Impact', value: 'Impact, Charcoal, sans-serif' },
    ]},
    { group: 'Fantaisie', items: [
      { name: 'Lobster', value: '"Lobster", cursive' },
      { name: 'Amatic SC', value: '"Amatic SC", cursive' },
      { name: 'Courier New', value: '"Courier New", Courier, monospace' },
    ]},
  ];

  var GOOGLE_FONTS_URL = 'https://fonts.googleapis.com/css2?family=Amatic+SC:wght@700&family=Bebas+Neue&family=Caveat:wght@600&family=Cinzel:wght@500&family=Cormorant+Garamond:wght@500&family=Dancing+Script:wght@600&family=EB+Garamond&family=Great+Vibes&family=Lobster&family=Montserrat:wght@500&family=Oswald:wght@500&family=Pacifico&family=Parisienne&family=Playfair+Display:wght@500&family=Poppins:wght@500&family=Raleway:wght@500&family=Sacramento&family=Satisfy&display=swap';
  var googleFontsLoaded = false;

  function loadGoogleFonts() {
    if (googleFontsLoaded) return;
    googleFontsLoaded = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = GOOGLE_FONTS_URL;
    document.head.appendChild(link);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { renderCanvas(); });
    }
  }

  /* Produits personnalisables — résolus dynamiquement depuis le catalogue à
     l'ouverture du configurateur : les images et variantes restent toujours
     à jour (fini les URL mortes après un ménage dans les fichiers Shopify).
     La liste ci-dessous sert de repli si le réseau échoue. */
  var CUSTOMIZABLE_HANDLES = [
    'grande-planche-a-decouper-personalise',
    'buche-gravee',
    'dessous-de-verre-personnalise',
    'planche-a-saucisson',
    'portes-cles-rond-carre',
    'spatule-a-crepes-personnalisable',
    'decapsuleur-personnalisable',
    'planche-contreplaque-personnalisee'
  ];
  /* Produits pour lesquels on propose le choix portrait/paysage (les produits
     ronds — bûche, dessous de verre — n'ont pas d'orientation). */
  var ROTATABLE_HANDLES = [
    'grande-planche-a-decouper-personalise',
    'planche-a-saucisson',
    /* la spatule et le décapsuleur se gravent dans les deux sens : le manche
       est long, un prénom tient mieux en paysage qu'en portrait */
    'spatule-a-crepes-personnalisable',
    'decapsuleur-personnalisable',
    /* planche décorative rectangulaire : un plan technique se grave aussi
       bien en hauteur qu'en largeur, c'est au client de choisir */
    'planche-contreplaque-personnalisee'
  ];
  /* Aperçus détourés : PNG transparents SANS ombre incrustée, utilisés à la
     place de la photo catalogue dans le configurateur uniquement (la fiche
     produit garde son packshot). L'ombre est alors dessinée par le
     configurateur — voir drawGroundShadow.
     Les URL viennent du thème (snippet product-customizer.liquid) : le fichier
     vit dans assets/, il suit donc les mises en ligne du thème et n'a pas à
     être re-téléversé à la main dans les fichiers Shopify. */
  var CUTOUT_PREVIEWS = window.BANCO_CUTOUT_PREVIEWS || {
    'planche-a-saucisson': 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/saucisson-cutout-v2.png'
  };
  /* Aperçus gravés de la grille : le même visuel que la vignette, mais gravé
     d'un exemple. Le survol le découvre — c'est ce qui fait comprendre au
     client, AVANT qu'il clique, que c'est sa photo qui ira là. Posés par le
     snippet product-customizer.liquid ; vide = simple absence d'effet. */
  var APERCUS_GRAVES = window.BANCO_APERCUS_GRAVES || {};
  /* Produits livrés en plusieurs présentations, au choix du client : la bûche
     part seule, se pose sur son chevalet, s'accroche par son œillet, ou les
     deux. Chaque combinaison a son aperçu (assets du thème) et sa variante
     Shopify — c'est elle qui porte le prix, supplément des deux compris. */
  var PRESENTATION_HANDLES = ['buche-gravee'];
  var PRESENTATION_RENDUS = window.BANCO_BUCHE_RENDUS || {};
  var PRESENTATION_VARIANTES = {
    'seule': 'Bûche seule',
    'pied': 'Avec pied',
    'oeillet': 'Avec œillet',
    'pied-oeillet': 'Pied + œillet'
  };
  /* Produits livrés en plusieurs FORMES, au choix du client : le porte-clés
     existe rond ou carré. Chaque forme a son aperçu détouré (asset du thème)
     et sa variante Shopify — le choix change donc l'article ajouté au panier
     ET l'image sur laquelle la gravure est composée. Même principe que les
     présentations de la bûche, en plus simple : les formes s'excluent. */
  var FORME_HANDLES = ['portes-cles-rond-carre'];
  var FORME_APERCUS = window.BANCO_FORME_APERCUS || {};
  var FORME_VARIANTES = { 'carre': 'Carré', 'rond': 'Rond' };

  var BANCO_PRODUCTS = [
    {
      handle: 'grande-planche-a-decouper-personalise',
      title: 'Planche à découper Personnalisée',
      subtitle: 'Bois massif — dès 22 €',
      variantId: 53464044536072,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/planche-packshot-blanc-v2.jpg?width=1200'
    },
    {
      handle: 'buche-gravee',
      title: 'Bûche gravée personnalisée',
      subtitle: 'Rondin de bois brut — dès 15 €',
      variantId: 53900373557512,
      /* les trois présentations sont recopiées ici et pas seulement lues dans
         le catalogue : un client qui clique avant la fin du rafraîchissement
         doit quand même être facturé le bon prix quand il coche les deux */
      optionName: 'Présentation',
      variants: [
        { id: 53900373557512, title: 'Avec pied', price: 15 },
        { id: 58453415559432, title: 'Avec œillet', price: 15 },
        { id: 58453415592200, title: 'Pied + œillet', price: 17 },
        { id: 58453872935176, title: 'Bûche seule', price: 15 }
      ],
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/buche-packshot-blanc-v2.jpg?width=1200'
    },
    {
      handle: 'dessous-de-verre-personnalise',
      title: 'Lots de 2 Dessous de Verre personnalisés',
      subtitle: 'Lot de 2 — 7 €',
      variantId: 53901978927368,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/dessous-packshot-blanc.jpg?width=1200'
    },
    {
      handle: 'planche-a-saucisson',
      title: 'Planche à saucisson personnalisable',
      subtitle: 'Taille unique — 17 €',
      variantId: 53133477282056,
      img: CUTOUT_PREVIEWS['planche-a-saucisson']
    },
    {
      /* Repli seulement : les variantes Rond/Carré (et leur prix) sont lues
         dans le catalogue au chargement — ici, la variante par défaut. */
      handle: 'portes-cles-rond-carre',
      title: 'Porte-clés personnalisé',
      subtitle: 'Rond ou carré — bois massif',
      variantId: 58500090331400,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/portecles-carre-packshot-blanc-v3.jpg?width=1200'
    }
    ,
    {
      handle: 'spatule-a-crepes-personnalisable',
      title: 'Spatule à crêpes personnalisable',
      subtitle: 'Bois massif — 7 €',
      variantId: 58507232903432,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/spatule-fond-blanc.jpg?width=1200'
    },
    {
      handle: 'decapsuleur-personnalisable',
      title: 'Décapsuleur personnalisable',
      subtitle: 'Bois et inox — 7 €',
      variantId: 58507234377992,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/decapsuleur-fond-blanc.jpg?width=1200'
    },
    {
      handle: 'planche-contreplaque-personnalisee',
      title: 'Planche contreplaqué personnalisée',
      subtitle: 'Contreplaqué — 9 €',
      variantId: 58508851052808,
      img: 'https://cdn.shopify.com/s/files/1/1009/7190/5288/files/planche-contreplaque-fond-blanc.jpg?width=1200'
    }
  ];
  var productsRefreshed = false;

  function formatEuros(price) {
    if (isNaN(price)) return '';
    return (price % 1 ? price.toFixed(2).replace('.', ',') : String(Math.round(price))) + ' €';
  }

  function refreshProducts() {
    if (productsRefreshed) return Promise.resolve();
    return fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var fresh = [];
        CUSTOMIZABLE_HANDLES.forEach(function (h) {
          var p = (data.products || []).find(function (x) { return x.handle === h; });
          if (!p || !p.variants || !p.variants.length) return;
          var v = p.variants[0];
          var img = p.images && p.images[0] ? p.images[0].src : '';
          /* 1200 px et non 800 : l'aperçu est affiché jusqu'à 720 px de large
             sur un écran Retina, une source de 800 px y remontait floue */
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          /* Une photo téléversée en HEIC (iPhone) reste servie en .heic :
             aucun navigateur de bureau ne sait la décoder, l'aperçu resterait
             vide. Le CDN Shopify sait la convertir à la volée. */
          if (img && /\.heic(\?|$)/i.test(img.split('?')[0] + '?')) img += '&format=jpg';
          if (CUTOUT_PREVIEWS[h]) img = CUTOUT_PREVIEWS[h];
          var price = parseFloat(v.price);
          var priceTxt = formatEuros(price);
          fresh.push({
            handle: h,
            title: p.title,
            subtitle: (p.variants.length > 1 ? 'Dès ' : '') + priceTxt,
            variantId: v.id,
            variants: p.variants.map(function (vv) {
              return { id: vv.id, title: vv.title, price: parseFloat(vv.price) };
            }),
            optionName: (p.options && p.options[0] && p.options[0].name) || 'Version',
            img: img
          });
        });
        if (fresh.length) {
          BANCO_PRODUCTS = fresh;
          productsRefreshed = true;
        }
      })
      .catch(function () { /* repli : liste statique ci-dessus */ });
  }

  /* Caches indexés par URL d'image (et non par variantId) : le préchargement a
     lieu AVANT le rafraîchissement du catalogue, donc avec les URL de repli
     ci-dessus. Une clé variantId — identique avant/après refresh — figeait
     l'ancienne photo dans l'aperçu alors que la grille affichait la nouvelle
     (packshot v2 sur l'accueil, v1 dans le configurateur). */
  var productImgCache = {};    /* canvas composés, clé = url (+ ':rot') */
  var productRawImgCache = {}; /* éléments Image bruts, clé = url */

  /* Build navigateur (+esm = dépendances résolues par jsDelivr) et modèle IA
     téléchargé par la librairie elle-même : la 1.4.5/dist/index.mjs livrée
     auparavant ne pouvait PAS fonctionner hors bundler — imports « lodash »
     non résolus et resources.json vide. */
  var BG_REMOVAL_CDN = 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.7.0/+esm';
  /* isnet_quint8 (entiers 8 bits) et pas le fp16 par défaut : mesuré sur la
     même photo, 9 s contre 128 s — onnxruntime-web n'accélère pas le float16
     sur processeur, il l'émule. Le modèle est aussi bien plus léger à
     télécharger, pour une découpe équivalente en gravure noir & blanc. */
  var BG_MODEL = 'isnet_quint8';
  var bgRemovalModule = null;

  /* Le modèle et le moteur ONNX pèsent 56 Mo (44,3 + 11,8), servis en 14
     morceaux par staticimgly.com — qui ne renvoie AUCUN en-tête Cache-Control
     (cf-cache-status: DYNAMIC). Sans consigne de cache, le navigateur les
     retélécharge à chaque visite : mesuré ~80 s sur une ligne à 0,7 Mo/s, et
     c'est TOUT ce temps que le client voyait « bloqué à 15 % ».
     On les range donc nous-mêmes dans le Cache Storage : premier détourage
     inchangé (la bande passante fait la loi), tous les suivants immédiats. */
  var BG_DATA_HOST = 'staticimgly.com';
  var BG_CACHE_NAME = 'banco-bg-model-1.7.0';
  var BG_TOTAL_BYTES = 56.2e6; /* estimation d'affichage, cf. resources.json */
  var bgBytesLoaded = 0;
  var bgFetchPatched = false;

  function installBgFetchCache() {
    if (bgFetchPatched || !window.caches || !window.fetch) return;
    bgFetchPatched = true;
    /* ménage : ne pas laisser 56 Mo d'un ancien modèle sur l'appareil du client */
    caches.keys().then(function (names) {
      names.forEach(function (n) {
        if (n.indexOf('banco-bg-model-') === 0 && n !== BG_CACHE_NAME) caches.delete(n);
      });
    }).catch(function () {});
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf(BG_DATA_HOST) === -1) return nativeFetch(input, init);
      return caches.open(BG_CACHE_NAME).then(function (cache) {
        return cache.match(url).then(function (hit) {
          /* déjà en cache : on compte la taille annoncée sans relire le flux —
             dupliquer 56 Mo de lecture juste pour animer la barre coûtait plus
             cher que le téléchargement évité */
          if (hit) {
            bgBytesLoaded += parseInt(hit.headers.get('content-length') || 0, 10) || 0;
            reportBgProgress();
            return hit;
          }
          return nativeFetch(input, init).then(function (res) {
            /* clone AVANT lecture : la librairie consomme le corps original */
            if (res && res.ok) {
              try { cache.put(url, res.clone()).catch(function () {}); } catch (e) {}
            }
            return countBgBytes(res);
          });
        });
      }).catch(function () { return nativeFetch(input, init); });
    };
  }

  /* Compte les octets reçus sur une copie du flux (l'original reste intact pour
     la librairie) : c'est ce qui fait avancer la barre morceau par morceau. */
  function countBgBytes(res) {
    if (!res || !res.body || !res.body.getReader) return res;
    var clone;
    try { clone = res.clone(); } catch (e) { return res; }
    var reader = clone.body.getReader();
    (function pump() {
      reader.read().then(function (r) {
        if (r.done) return;
        bgBytesLoaded += r.value.byteLength;
        reportBgProgress();
        pump();
      }).catch(function () {});
    })();
    return res;
  }

  var bgProgressLast = 0;
  function reportBgProgress() {
    var now = Date.now();
    if (now - bgProgressLast < 200) return;
    bgProgressLast = now;
    if (!loaderVisible()) return; /* voile masqué : rien à animer */
    /* modèle déjà en mémoire : il n'y a plus de téléchargement à raconter. Sans
       ce garde-fou, la 2e photo de la visite voyait la barre sauter d'un coup à
       la moitié de l'étape 2 pour un travail qui n'avait pas lieu. */
    if (bgModelReady) return;
    var ratio = Math.min(bgBytesLoaded / BG_TOTAL_BYTES, 1);
    /* première visite : le téléchargement du modèle occupe l'essentiel de
       l'attente — il pilote la première moitié du segment de l'étape 2 */
    setProcessingUI(2, ratio * BG_PART_MODELE,
      'Chargement de l\'IA (une seule fois) — ' +
      Math.round(ratio * BG_TOTAL_BYTES / 1e6) + ' Mo sur ' + Math.round(BG_TOTAL_BYTES / 1e6) + ' Mo');
  }

  var nextId = 1;
  var modal, canvas, ctx;
  var stepProducts, stepCustomizer;
  var elementsListEl;

  var state = {
    selectedProduct: null,
    variantId: null,
    elements: [],
    selectedId: null,
    drag: null,
    productBgCanvas: null,
    productBgImg: null,
    productBgReady: false,
    productFade: 1,        /* 0→1 : fondu d'arrivée du produit dans l'aperçu */
    productRotated: false, /* true = aperçu produit tourné à 90° (paysage) */
    presPied: false,       /* présentation choisie : œillet et/ou chevalet */
    presOeillet: true,     /* l'œillet est la présentation par défaut */
    forme: 'carre',        /* forme choisie (porte-clés) : 'carre' ou 'rond' */
    liveTextId: null,
    tailleTexteAuto: true, /* le corps du texte suit la zone gravable tant que
                              le client n'a pas touché au curseur de taille */
    photoLoading: false /* import en cours : détourage + conversion gravure */
  };

  // --- INIT ---

  function init() {
    /* Déclencheurs : bouton du hero (#banco-customizer-btn) + boutons des
       pages produit ([data-banco-customizer], avec data-banco-handle pour
       pré-sélectionner le produit de la page). */
    var triggerBtns = document.querySelectorAll('#banco-customizer-btn, [data-banco-customizer]');
    if (!triggerBtns.length) return;

    modal = document.getElementById('banco-customizer-modal');
    canvas = document.getElementById('banco-canvas');
    stepProducts = document.getElementById('banco-step-products');
    stepCustomizer = document.getElementById('banco-step-customizer');
    elementsListEl = document.getElementById('banco-elements-list');

    if (!modal || !canvas) return;

    // Supprimer les modals en double (snippet rendu plusieurs fois par les sections)
    document.querySelectorAll('#banco-customizer-modal').forEach(function (m, i) {
      if (i > 0) m.parentNode.removeChild(m);
    });

    // Move modal to <body> to escape any ancestor transform that traps position:fixed
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    ctx = canvas.getContext('2d');
    applyCanvasResolution();
    /* changement d'écran (fenêtre redimensionnée, passage sur un moniteur
       externe) : on recompose l'aperçu à la bonne finesse */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!modal.classList.contains('banco-open')) return;
        if (applyCanvasResolution() && state.selectedProduct) {
          applyProductBackground(state.selectedProduct, true);
        }
      }, 200);
    });

    triggerBtns.forEach(function (btn) {
      /* le survol/effleurement d'un bouton « Personnaliser » lance déjà le
         téléchargement du modèle : quelques secondes gagnées avant l'import de
         la photo, et rien de perdu si le client ne clique pas (le fichier reste
         en cache pour sa prochaine visite) */
      ['pointerenter', 'focus', 'touchstart'].forEach(function (evt) {
        btn.addEventListener(evt, function () { preloadBgRemoval(); }, { passive: true, once: true });
      });
      btn.addEventListener('click', function (e) {
        /* preventDefault : certains déclencheurs vivent dans un lien
           (cartes de la grille produits) — le clic ne doit pas naviguer */
        e.preventDefault();
        e.stopPropagation();
        openModal(btn.getAttribute('data-banco-handle') || null, btn);
      });
    });
    modal.querySelector('.banco-modal-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('banco-open')) closeModal();
    });

    document.getElementById('banco-back-to-products').addEventListener('click', function () {
      /* la grille peut ne pas avoir été rendue si on est arrivé directement
         à l'étape 2 depuis une page produit */
      renderProductGrid();
      preloadProductImages();
      showProductStep();
    });

    /* Mention sous l'aperçu : « une photo mal détournée ? dites-le dans
       l'espace commentaire ». Le bouton y conduit vraiment — sinon le client
       lit la consigne et doit ensuite chercher le champ dans la colonne. */
    var noteCta = document.getElementById('banco-sim-note-cta');
    if (noteCta) {
      noteCta.addEventListener('click', function () {
        var bloc = document.getElementById('banco-tab-notes');
        var champ = document.getElementById('banco-instructions');
        if (bloc) {
          bloc.scrollIntoView({
            behavior: mouvementReduit() ? 'auto' : 'smooth',
            block: 'center'
          });
        }
        if (!champ) return;
        /* onde chaude sur le champ : le défilement seul ne dit pas OÙ écrire */
        champ.classList.remove('banco-cible');
        void champ.offsetWidth;
        champ.classList.add('banco-cible');
        setTimeout(function () { champ.focus({ preventScroll: true }); }, 320);
        setTimeout(function () { champ.classList.remove('banco-cible'); }, 1900);
      });
    }

    modal.querySelectorAll('.banco-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modal.querySelectorAll('.banco-tab').forEach(function (t) { t.classList.remove('active'); });
        modal.querySelectorAll('.banco-tab-content').forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        document.getElementById('banco-tab-' + tab.dataset.tab).classList.add('active');
      });
    });

    var fontSelect = document.getElementById('banco-font-family');
    FONTS.forEach(function (g) {
      var grp = document.createElement('optgroup');
      grp.label = g.group;
      g.items.forEach(function (f) {
        var opt = document.createElement('option');
        opt.value = f.value;
        opt.textContent = f.name;
        opt.style.fontFamily = f.value; /* aperçu direct dans la liste */
        grp.appendChild(opt);
      });
      fontSelect.appendChild(grp);
    });

    /* dès que le client touche au corps du texte, il reprend la main : on
       arrête de l'ajuster automatiquement à la zone gravable (écouteur posé
       AVANT bindRange pour que le drapeau tombe avant le re-rendu) */
    var champTaille = document.getElementById('banco-font-size');
    if (champTaille) {
      champTaille.addEventListener('input', function () { state.tailleTexteAuto = false; });
    }
    bindRange('banco-font-size', 'banco-font-size-val', function (v) { return v + 'px'; }, onTextLiveInput);

    var contrastInput = document.getElementById('banco-engrave-contrast');
    var contrastVal = document.getElementById('banco-engrave-contrast-val');
    if (contrastInput) {
      majRemplissage(contrastInput);
      contrastInput.addEventListener('input', function () {
        if (contrastVal) contrastVal.textContent = this.value;
        majRemplissage(this);
        rebuildEngravings(true, parseInt(this.value, 10) / 100);
      });
      contrastInput.addEventListener('change', function () {
        rebuildEngravings(false, parseInt(this.value, 10) / 100);
      });
    }
    var showOriginalCb = document.getElementById('banco-show-original');
    if (showOriginalCb) {
      showOriginalCb.addEventListener('change', function () {
        var on = this.checked;
        state.elements.forEach(function (el) { if (el.type === 'image') el.showOriginal = on; });
        renderCanvas();
      });
    }
    var removeBgCb = document.getElementById('banco-remove-bg');
    if (removeBgCb) {
      removeBgCb.addEventListener('change', function () { setBackgroundRemoved(this.checked); });
    }

    var variantSelect = document.getElementById('banco-variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        state.variantId = parseInt(this.value, 10) || this.value;
      });
    }

    var orientPortrait = document.getElementById('banco-orient-portrait');
    var orientPaysage = document.getElementById('banco-orient-paysage');
    if (orientPortrait) orientPortrait.addEventListener('click', function () { setOrientation(false); });
    if (orientPaysage) orientPaysage.addEventListener('click', function () { setOrientation(true); });

    var formeCarre = document.getElementById('banco-forme-carre');
    var formeRond = document.getElementById('banco-forme-rond');
    if (formeCarre) formeCarre.addEventListener('click', function () { setForme('carre'); });
    if (formeRond) formeRond.addEventListener('click', function () { setForme('rond'); });

    var presPied = document.getElementById('banco-pres-pied');
    var presOeillet = document.getElementById('banco-pres-oeillet');
    if (presPied) presPied.addEventListener('change', function () {
      setPresentation(this.checked, state.presOeillet);
    });
    if (presOeillet) presOeillet.addEventListener('change', function () {
      setPresentation(state.presPied, this.checked);
    });

    document.getElementById('banco-text-input').addEventListener('input', onTextLiveInput);
    document.getElementById('banco-font-family').addEventListener('change', onTextLiveInput);
    document.getElementById('banco-bold').addEventListener('change', onTextLiveInput);
    document.getElementById('banco-italic').addEventListener('change', onTextLiveInput);

    document.getElementById('banco-image-input').addEventListener('change', function () {
      if (this.files && this.files[0]) addImageAsync(this.files[0]);
    });

    var instructions = document.getElementById('banco-instructions');
    if (instructions) {
      instructions.addEventListener('input', updateInstructionsCount);
    }

    initDropzone();

    document.getElementById('banco-add-to-cart').addEventListener('click', addToCart);

    canvas.addEventListener('mousedown', onMouseDown);
    canvas.addEventListener('mousemove', onMouseMove);
    canvas.addEventListener('mouseup', onMouseUp);
    canvas.addEventListener('mouseleave', onMouseUp);
    canvas.addEventListener('touchstart', function (e) { e.preventDefault(); onMouseDown(touchToMouse(e)); }, { passive: false });
    canvas.addEventListener('touchmove', function (e) { e.preventDefault(); onMouseMove(touchToMouse(e)); }, { passive: false });
    canvas.addEventListener('touchend', onMouseUp);
  }

  /* Part déjà parcourue du curseur, pour peindre la piste (voir
     --banco-fill dans product-customizer.css). La piste native ne montrait
     pas où l'on en était : le réglage se lisait uniquement sur le chiffre. */
  function majRemplissage(input) {
    if (!input) return;
    var min = parseFloat(input.min || 0), max = parseFloat(input.max || 100);
    var v = parseFloat(input.value);
    var part = max > min ? (v - min) / (max - min) : 0;
    input.style.setProperty('--banco-fill', (part * 100).toFixed(1) + '%');
  }
  window.bancoMajRemplissage = majRemplissage;

  function bindRange(inputId, displayId, format, onChange) {
    var input = document.getElementById(inputId);
    var display = document.getElementById(displayId);
    if (!input || !display) return;
    display.textContent = format(input.value);
    majRemplissage(input);
    input.addEventListener('input', function () {
      display.textContent = format(this.value);
      majRemplissage(this);
      if (onChange) onChange();
    });
  }

  // --- REAL-TIME TEXT ---

  /* Largeur réelle du texte pour une police et un corps donnés. */
  function largeurTexte(text, font, size, bold, italic) {
    if (!ctx) return text.length * size * 0.5;
    ctx.save();
    ctx.font = (italic ? 'italic ' : '') + (bold ? 'bold ' : '') + size + 'px ' + font;
    var max = 0;
    text.split('\n').forEach(function (ligne) {
      var w = ctx.measureText(ligne).width;
      if (w > max) max = w;
    });
    ctx.restore();
    return max;
  }

  /* Corps le plus grand qui tienne dans la zone gravable. Sans cela, le corps
     par défaut (32 px) débordait de la planche dès qu'on tapait un nom un peu
     long ou qu'on choisissait une anglaise — le client voyait sa gravure
     dépasser du bois. Dès qu'il touche le curseur, il reprend la main. */
  function tailleAjustee(text, font, size, bold, italic, zone) {
    var lignes = text.split('\n').length;
    var large = largeurTexte(text, font, size, bold, italic);
    var f = 1;
    if (large > zone.w) f = zone.w / large;
    var hauteur = lignes * size * 1.28 * f;
    if (hauteur > zone.h) f *= zone.h / hauteur;
    return Math.max(10, Math.min(size, Math.floor(size * f)));
  }

  function onTextLiveInput() {
    var textarea = document.getElementById('banco-text-input');
    var text = textarea ? textarea.value : '';
    var font = document.getElementById('banco-font-family').value;
    var size = parseInt(document.getElementById('banco-font-size').value, 10);
    var bold = document.getElementById('banco-bold').checked;
    var italic = document.getElementById('banco-italic').checked;

    /* les polices Google se chargent à la demande : re-rendre dès qu'elle arrive */
    if (document.fonts && !document.fonts.check('16px ' + font)) {
      document.fonts.load('16px ' + font).then(function () { renderCanvas(); });
    }

    if (!text.trim()) {
      if (state.liveTextId !== null) {
        state.elements = state.elements.filter(function (e) { return e.id !== state.liveTextId; });
        if (state.selectedId === state.liveTextId) state.selectedId = null;
        state.liveTextId = null;
        renderCanvas();
        renderElementsList();
      }
      return;
    }

    /* tant que le curseur n'a pas été touché, le texte se cale tout seul sur
       la largeur gravable du produit */
    var zoneTexte = zoneGravure();
    if (state.tailleTexteAuto) size = tailleAjustee(text, font, size, bold, italic, zoneTexte);

    var existing = state.elements.find(function (e) { return e.id === state.liveTextId; });
    if (existing && existing.type === 'text') {
      var ancienneLargeur = largeurTexte(existing.text, existing.font, existing.size, existing.bold, existing.italic);
      existing.text = text;
      existing.font = font;
      existing.size = size;
      existing.bold = bold;
      existing.italic = italic;
      /* le texte reste centré sur lui-même pendant la frappe au lieu de
         s'étirer vers la droite jusqu'à sortir de la planche */
      if (state.tailleTexteAuto && !existing._deplaceALaMain) {
        var nouvelleLargeur = largeurTexte(text, font, size, bold, italic);
        existing.x = Math.round(Math.max(zoneTexte.x, Math.min(
          existing.x + (ancienneLargeur - nouvelleLargeur) / 2,
          zoneTexte.x + zoneTexte.w - nouvelleLargeur)));
      }
      renderCanvas();
    } else {
      /* Le texte naissait en haut à gauche du canevas, c'est-à-dire à côté du
         produit, sur le fond : il fallait le rattraper à la souris à chaque
         fois. Il apparaît maintenant dans la zone gravable, sous la photo si
         elle est là, centré au jugé sur la largeur du texte. */
      var zone = zoneTexte;
      var rang = state.elements.filter(function (e) { return e.type === 'text'; }).length % 4;
      /* largeur RÉELLE du texte, mesurée avec sa police : une estimation au
         nombre de caractères débordait de la planche dès qu'on choisissait une
         anglaise, bien plus large qu'une linéale */
      var largeurApprox = Math.min(zone.w, largeurTexte(text, font, size, bold, italic) || zone.w);
      var photo = imageEls()[0];
      var basPhoto = photo ? photo.y + photo.h + 8 : zone.y + zone.h * 0.62;
      var el = {
        id: nextId++, type: 'text',
        text: text, font: font, size: size, bold: bold, italic: italic,
        x: Math.round(Math.max(zone.x, Math.min(
          zone.x + (zone.w - largeurApprox) / 2,
          zone.x + zone.w - largeurApprox))),
        y: Math.round(Math.min(basPhoto + rang * size * 1.4, zone.y + zone.h - size)),
        _bounds: null,
      };
      state.elements.push(el);
      state.liveTextId = el.id;
      state.selectedId = el.id;
      renderCanvas();
      renderElementsList();
    }
  }

  // --- MODAL ---

  function preloadProductImages() {
    var urls = BANCO_PRODUCTS.map(function (product) { return product.img; });
    /* les présentations de la bûche aussi : cocher une case doit changer
       l'aperçu tout de suite, pas après un aller-retour réseau */
    Object.keys(PRESENTATION_RENDUS).forEach(function (k) { urls.push(PRESENTATION_RENDUS[k]); });
    /* et les formes : passer de carré à rond ne doit pas attendre le réseau */
    Object.keys(FORME_APERCUS).forEach(function (h) {
      Object.keys(FORME_APERCUS[h] || {}).forEach(function (k) { urls.push(FORME_APERCUS[h][k]); });
    });
    urls.forEach(function (url) {
      if (!url || productRawImgCache[url]) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        productRawImgCache[url] = img;
        productImgCache[url] = buildColorCanvas(img, false);
      };
      img.src = url;
    });
  }

  /* ======================================================================
     MOUVEMENT — refonte du 09/08/2026

     Trois gestes, tous fondés sur le même principe : rien n'apparaît ni ne
     disparaît, tout se DÉPLACE. Un objet qui se remplace par fondu oblige le
     client à retrouver où il est passé ; un objet qui voyage se suit tout
     seul.

     1. la modale naît du bouton qui l'ouvre (origineDepuis) ;
     2. l'article choisi vole de la grille jusqu'à l'aperçu (volerVersApercu) ;
     3. le voile de préparation se retire VERS la photo qu'il vient de
        préparer (fuiteDuVoile).

     Le tout en Web Animations, avec les mêmes courbes de ressort que la CSS —
     elles sont lues dans les variables du thème, une seule source de vérité.
     ====================================================================== */

  function courbe(nom, repli) {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(nom).trim();
      /* un navigateur sans linear() renverrait quand même la chaîne : on
         vérifie qu'il sait l'interpréter avant de la donner à WAAPI */
      if (v && (v.indexOf('linear(') !== 0 || CSS.supports('transition-timing-function', v))) return v;
    } catch (e) { /* CSS.supports absent : on retombe sur la cubic-bezier */ }
    return repli || 'cubic-bezier(0.16, 1, 0.3, 1)';
  }

  /* Point de fuite du zoom d'ouverture : le centre du bouton cliqué, exprimé
     en pourcentage du panneau. Hors panneau (bouton en bas de page, panneau
     plein écran) la valeur est bornée pour que le zoom reste lisible. */
  function origineDepuis(el) {
    var inner = modal.querySelector('.banco-modal-inner');
    if (!inner) return;
    if (!el || !el.getBoundingClientRect) {
      inner.style.removeProperty('--banco-ox');
      inner.style.removeProperty('--banco-oy');
      return;
    }
    var b = el.getBoundingClientRect();
    var p = inner.getBoundingClientRect();
    if (!p.width || !p.height) return;
    var fx = ((b.left + b.width / 2) - p.left) / p.width * 100;
    var fy = ((b.top + b.height / 2) - p.top) / p.height * 100;
    inner.style.setProperty('--banco-ox', Math.max(-15, Math.min(115, fx)).toFixed(1) + '%');
    inner.style.setProperty('--banco-oy', Math.max(-15, Math.min(115, fy)).toFixed(1) + '%');
  }

  /* Rectangle réellement occupé par le contenu d'une <img> en object-fit:
     contain — et non celui de la balise. Sans ça, un packshot non carré
     « saute » au démarrage du vol, puisqu'il flotte dans sa vignette. */
  function boiteContenu(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh || !r.width || !r.height) return r;
    var cs = getComputedStyle(img);
    var px = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var py = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var dispo_w = r.width - px, dispo_h = r.height - py;
    var f = Math.min(dispo_w / nw, dispo_h / nh);
    var w = nw * f, h = nh * f;
    return {
      left: r.left + px / 2 + (dispo_w - w) / 2,
      top: r.top + py / 2 + (dispo_h - h) / 2,
      width: w, height: h
    };
  }

  /* Où l'article va se poser sur le canevas, en pixels d'écran. On réutilise
     poseProduit() — la fonction qui dessine vraiment — donc l'atterrissage
     tombe exactement sur le produit peint, pas « à peu près ». */
  function boiteArriveeProduit(img) {
    var scene = modal.querySelector('.banco-canvas-stage');
    if (!scene) return null;
    var r = scene.getBoundingClientRect();
    if (!r.width) return null;
    var k = r.width / CANVAS_W;
    var p = poseProduit(img, 0);
    var w = p.nw * p.sc, h = p.nh * p.sc;
    return {
      left: r.left + (CANVAS_W / 2 - p.dx - w / 2) * k,
      top: r.top + (CANVAS_H / 2 - p.dy - h / 2) * k,
      width: w * k, height: h * k
    };
  }

  var volEnCours = null;
  function volerVersApercu(carte, product, montrerEtape2) {
    var vignette = carte && carte.querySelector('img');
    var zone = modal.querySelector('.banco-canvas-area');
    /* L'image du cache est celle qui PEINDRA le canevas : c'est elle qui donne
       le cadre utile et l'échelle. Sans elle (clic très rapide, avant la fin du
       préchargement), on volerait d'après une autre mesure — les images du
       catalogue arrivent d'un autre domaine et ne sont donc pas analysables —
       et l'article se poserait à côté. Dans ce cas on renonce au vol : la
       bascule d'étape garde sa propre mise en scène. */
    var ref = vignette && productRawImgCache[product.img];
    if (mouvementReduit() || !vignette || !vignette.naturalWidth || !ref ||
        !zone || !document.body.animate) {
      montrerEtape2();
      return;
    }

    var depart = boiteContenu(vignette);
    /* l'article choisi s'enfonce, les autres s'écartent : la grille commente
       le choix au lieu de disparaître d'un bloc */
    carte.classList.add('banco-choisie');
    var grille = document.getElementById('banco-products-grid');
    if (grille) {
      Array.prototype.forEach.call(grille.children, function (c) {
        if (c !== carte) c.classList.add('banco-ecartee');
      });
    }

    montrerEtape2();

    var arrivee = boiteArriveeProduit(ref);
    if (!arrivee) return; /* scène non mesurable : on reste sur la bascule simple */

    var vol = document.createElement('img');
    vol.className = 'banco-vol';
    vol.alt = '';
    vol.setAttribute('aria-hidden', 'true');
    vol.src = vignette.currentSrc || vignette.src;
    /* On ne fait pas voler la vignette entière : les packshots sont des
       articles posés sur un carré BLANC, invisible dans sa carte blanche mais
       très visible en vol au-dessus de l'ivoire. On rogne donc sur le cadre
       utile — la même mesure que celle qui sert à dessiner le produit — pour
       qu'un ARTICLE traverse l'écran, et non une vignette. Le rognage est une
       fraction de l'élément : il suit tout seul la mise à l'échelle du vol.
       Si l'analyse a échoué (image d'un autre domaine, non lisible), la boîte
       vaut l'image entière et le rognage ne fait rien. */
    var cadre = boiteProduit(ref);
    if (cadre.x1 - cadre.x0 < 0.995 || cadre.y1 - cadre.y0 < 0.995) {
      vol.style.clipPath = 'inset(' + (cadre.y0 * 100).toFixed(2) + '% ' +
        ((1 - cadre.x1) * 100).toFixed(2) + '% ' + ((1 - cadre.y1) * 100).toFixed(2) + '% ' +
        (cadre.x0 * 100).toFixed(2) + '%)';
    }
    vol.style.left = depart.left + 'px';
    vol.style.top = depart.top + 'px';
    vol.style.width = depart.width + 'px';
    vol.style.height = depart.height + 'px';
    vol.style.transformOrigin = 'top left';
    document.body.appendChild(vol);

    var dx = arrivee.left - depart.left;
    var dy = arrivee.top - depart.top;
    var s = arrivee.width / depart.width;
    var duree = 620;

    if (volEnCours) { try { volEnCours.cancel(); } catch (e) {} }
    /* PIÈGE MESURÉ EN PRODUCTION (09/08/2026) : dans une animation, les
       `offset` des étapes se comparent à la progression DÉJÀ ADOUCIE par la
       courbe. Avec un ressort — qui atteint 98 % de sa course à 46 % du temps —
       une étape posée à 0,72 tombe en réalité vers 30 % du temps : la copie
       s'effaçait à 280 ms alors que le canevas ne revenait qu'à 370 ms, d'où
       un trou de 90 ms où l'aperçu était vide. Le déplacement et le fondu sont
       donc deux animations séparées : la première porte le ressort, la seconde
       une simple rampe linéaire dont on maîtrise l'instant. */
    volEnCours = vol.animate([
      { transform: 'translate(0px, 0px) scale(1)' },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + s + ')' }
    ], { duration: duree, easing: courbe('--banco-ressort-doux'), fill: 'forwards' });

    /* Ordre voulu, en temps réel : vers 260 ms le canevas revient en fondu SOUS
       la copie, qui est alors posée et encore opaque — les deux images
       coïncident, il n'y a rien à voir ; à partir de 330 ms la copie s'efface
       par-dessus. Aucun instant sans produit à l'écran.

       DEUXIÈME PIÈGE MESURÉ : peindre le produit bloque le fil principal
       (~650 ms sur cette machine, davantage sur un téléphone). Tout relais
       confié au fil principal — minuterie OU `onfinish` — arrive donc en
       retard, pendant que la copie, elle, s'est effacée à l'heure sur le
       compositeur : l'aperçu se retrouvait vide un tiers de seconde. Les deux
       fondus sont donc des animations du compositeur, qui tournent même
       lorsque le JS est bloqué. Plus aucun code n'a besoin de « rendre la
       main » au bon moment. */
    vol.animate([{ opacity: 1 }, { opacity: 0 }],
      { delay: Math.round(duree * 0.53), duration: Math.round(duree * 0.36),
        easing: 'linear', fill: 'forwards' });

    canvas.animate([
      { opacity: 0, offset: 0 },
      { opacity: 0, offset: 0.42 },
      { opacity: 1, offset: 0.62 },
      { opacity: 1, offset: 1 }
    ], { duration: duree, easing: 'linear' });

    var fin = function () {
      if (vol.parentNode) vol.parentNode.removeChild(vol);
      volEnCours = null;
    };
    volEnCours.onfinish = fin;
    volEnCours.oncancel = fin;
    /* filet : si l'animation ne rend jamais la main (onglet masqué à l'instant
       du clic), le calque ne doit pas rester en travers de l'écran */
    setTimeout(function () { if (volEnCours) fin(); }, duree + 2500);
  }

  /* Le voile ne se dissout pas sur place : il se retire VERS la photo qu'il
     vient de préparer, qui prend le relais avec sa gravure au laser. */
  function fuiteDuVoile(box) {
    var carte = box.querySelector('.banco-loader-card');
    if (!carte || mouvementReduit()) return;
    var cible = null;
    for (var i = 0; i < state.elements.length; i++) {
      if (state.elements[i].type === 'image') { cible = state.elements[i]; break; }
    }
    var scene = modal.querySelector('.banco-canvas-stage');
    if (!cible || !scene) return;
    var r = scene.getBoundingClientRect();
    if (!r.width) return;
    var k = r.width / CANVAS_W;
    var b = carte.getBoundingClientRect();
    var vx = (r.left + (cible.x + cible.w / 2) * k) - (b.left + b.width / 2);
    var vy = (r.top + (cible.y + cible.h / 2) * k) - (b.top + b.height / 2);
    /* course bornée : le voile doit indiquer une direction, pas traverser
       l'écran — au-delà de ~90 px le geste devient une fuite, pas un passage */
    var d = Math.hypot(vx, vy) || 1;
    var f = Math.min(1, 90 / d);
    carte.style.setProperty('--banco-fuite-x', (vx * f).toFixed(1) + 'px');
    carte.style.setProperty('--banco-fuite-y', (vy * f).toFixed(1) + 'px');
  }

  function openModal(preselectHandle, declencheur) {
    loadGoogleFonts();
    preloadBgRemoval(); /* le modèle IA se télécharge pendant le choix du produit */
    /* réouverture pendant la fermeture : on coupe court à l'animation de sortie,
       et retirer/reposer banco-open rejoue bien l'animation d'entrée */
    clearTimeout(fermetureTimer);
    modal.classList.remove('banco-closing');
    modal.classList.add('banco-open');
    /* mesuré APRÈS l'ajout de la classe (le panneau était en display:none, donc
       sans dimensions) mais dans la MÊME tâche JS : rien n'a encore été peint,
       l'animation démarrera déjà avec le bon point de fuite */
    origineDepuis(declencheur);
    document.body.style.overflow = 'hidden';
    showProductStep();

    /* Ouverture depuis une page produit : l'étape « Choisir » est sautée,
       le produit de la page est pré-sélectionné ("Changer de produit"
       permet toujours de revenir à la grille). */
    if (preselectHandle) {
      var grid = document.getElementById('banco-products-grid');
      var loading = document.getElementById('banco-products-loading');
      if (grid) grid.innerHTML = '';
      if (loading) loading.style.display = '';
      refreshProducts().then(function () {
        if (!modal.classList.contains('banco-open')) return;
        preloadProductImages();
        var product = BANCO_PRODUCTS.find(function (p) { return p.handle === preselectHandle; });
        if (product) { selectProduct(product); return; }
        renderProductGrid(); /* repli : produit inconnu → choix classique */
      });
      return;
    }

    renderProductGrid();
    preloadProductImages();
    /* rafraîchir depuis le catalogue, puis re-rendre si toujours à l'étape 1 */
    refreshProducts().then(function () {
      if (productsRefreshed && modal.classList.contains('banco-open') && stepProducts.style.display !== 'none') {
        renderProductGrid();
        preloadProductImages();
      }
    });
  }

  /* Fermeture : le panneau redescend et se dissout avant d'être masqué. Le
     `display:none` doit donc attendre la fin de l'animation — d'où le minuteur.
     Durée alignée sur banco-modale-out dans product-customizer.css. */
  var fermetureTimer = null;
  function closeModal() {
    if (!modal.classList.contains('banco-open')) return;
    document.body.style.overflow = '';
    if (mouvementReduit()) {
      modal.classList.remove('banco-open', 'banco-closing');
      return;
    }
    modal.classList.add('banco-closing');
    clearTimeout(fermetureTimer);
    fermetureTimer = setTimeout(function () {
      modal.classList.remove('banco-open', 'banco-closing');
    }, 300);
  }

  function showProductStep() {
    stepCustomizer.style.display = 'none';
    stepProducts.style.display = 'flex';
    stepProducts.classList.remove('animating-in', 'animating-out');
    void stepProducts.offsetWidth;
    stepProducts.classList.add('animating-in');
    setStepBar(1);
  }

  function showCustomizerStep() {
    stepProducts.style.display = 'none';
    stepCustomizer.style.display = 'flex';
    stepCustomizer.classList.remove('animating-in', 'animating-out');
    void stepCustomizer.offsetWidth;
    stepCustomizer.classList.add('animating-in');
    setStepBar(2);
    /* l'aperçu est visible : sa largeur réelle est enfin connue, on cale la
       finesse dessus (à l'ouverture, la modale était encore masquée) */
    if (applyCanvasResolution() && state.selectedProduct && state.productBgCanvas) {
      applyProductBackground(state.selectedProduct, true);
    }
    renderCanvas();
  }

  function setStepBar(active) {
    modal.querySelectorAll('.banco-step-item').forEach(function (s, i) {
      s.classList.remove('active', 'done');
      if (i + 1 < active) s.classList.add('done');
      else if (i + 1 === active) s.classList.add('active');
    });
    modal.querySelectorAll('.banco-step-line').forEach(function (l, i) {
      l.classList.toggle('done', i + 1 < active);
    });
  }

  // --- PRODUCTS ---

  function renderProductGrid() {
    var grid = document.getElementById('banco-products-grid');
    var loading = document.getElementById('banco-products-loading');
    if (loading) loading.style.display = 'none';
    grid.innerHTML = '';
    BANCO_PRODUCTS.forEach(function (product, index) {
      var card = document.createElement('div');
      card.className = 'banco-product-card';
      /* les cartes entrent en cascade — l'ordre de lecture est donné par
         l'animation, sans que le client ait à balayer la grille des yeux */
      card.style.setProperty('--banco-rang', String(index));
      /* la vignette est enveloppée : il faut une boîte qui rogne pour que le
         balayage de gravure au survol s'arrête au cadre de la photo */
      var grave = APERCUS_GRAVES[product.handle];
      card.innerHTML =
        '<span class="banco-card-shot">' +
        '<img src="' + product.img + '" alt="' + escapeHtml(product.title) + '">' +
        (grave
          ? '<img class="banco-card-grave" src="' + grave + '" alt="" aria-hidden="true">'
          : '') +
        '</span>' +
        '<div class="banco-product-name">' + escapeHtml(product.title) + '</div>' +
        '<div class="banco-product-subtitle">' + escapeHtml(product.subtitle) + '</div>';
      card.addEventListener('click', function () { selectProduct(product, card); });
      var cardImg = card.querySelector('img:not(.banco-card-grave)');
      if (cardImg) cardImg.addEventListener('error', function () { cardImg.style.opacity = '0'; });
      grid.appendChild(card);
    });
  }

  function selectProduct(product, carte) {
    state.selectedProduct = product;
    state.variantId = product.variantId;
    state.elements = [];
    state.selectedId = null;
    state.productBgCanvas = null;
    state.productBgImg = null;
    state.productBgReady = false;
    state.productRotated = false;
    if (orientAnimId) { cancelAnimationFrame(orientAnimId); orientAnimId = null; }
    orientAngle = 0;
    state.liveTextId = null;
    /* nouvel article, nouvelle zone gravable : le texte se recale dessus */
    state.tailleTexteAuto = true;
    canvas.style.filter = '';

    var textarea = document.getElementById('banco-text-input');
    if (textarea) textarea.value = '';

    /* le voile de préparation appartient à l'aperçu précédent : on l'efface.
       Le détourage éventuellement en cours se termine dans le vide et libère
       state.photoLoading tout seul. */
    closePhotoLoader();

    var instructions = document.getElementById('banco-instructions');
    if (instructions) instructions.value = '';
    updateInstructionsCount();

    document.getElementById('banco-selected-product-name').textContent = product.title;

    /* Choix de la variante (ex. taille de planche) quand le produit en a
       plusieurs — sinon le champ reste masqué. Les variantes de la bûche, elles,
       ne sont pas choisies dans cette liste : ce sont les cases « Présentation »
       qui les désignent, et une liste déroulante en plus dirait deux fois la
       même chose. */
    var variantField = document.getElementById('banco-variant-field');
    var variantSelect = document.getElementById('banco-variant-select');
    if (variantField && variantSelect) {
      if (product.variants && product.variants.length > 1 &&
          PRESENTATION_HANDLES.indexOf(product.handle) === -1 &&
          !aFormeChoisie(product)) {
        var variantLabel = document.getElementById('banco-variant-label');
        if (variantLabel) variantLabel.textContent = product.optionName || 'Version';
        variantSelect.innerHTML = '';
        product.variants.forEach(function (vv) {
          var opt = document.createElement('option');
          opt.value = vv.id;
          var pTxt = formatEuros(vv.price);
          opt.textContent = vv.title + (pTxt ? ' — ' + pTxt : '');
          variantSelect.appendChild(opt);
        });
        variantSelect.value = String(product.variantId);
        variantField.style.display = '';
      } else {
        variantField.style.display = 'none';
      }
    }

    updatePresentationControls(product);
    updateFormeControls(product);
    updateOrientationControls(product);
    updateEngraveControls();
    renderElementsList();

    /* L'article choisi vole de la grille jusqu'à l'aperçu. La bascule d'étape
       et la peinture du canevas se font DANS le vol (voir volerVersApercu),
       pour que la scène soit mesurable au moment de viser l'atterrissage.
       Sans carte d'origine — arrivée directe depuis une page produit — on
       bascule simplement. */
    volerVersApercu(carte, product, function () {
      showCustomizerStep();
      applyProductBackground(product);
    });
  }

  function loadProductFallback(url) {
    var img = new Image();
    img.onload = function () {
      state.productBgImg = img;
      state.productBgReady = false;
      canvas.style.filter = '';
      showCustomizerStep();
    };
    img.onerror = function () { showCustomizerStep(); };
    img.src = url;
  }

  /* --- Ombre au sol dessinée par le configurateur ----------------------
     Pour les produits dont l'aperçu est un PNG détouré (voir CUTOUT_PREVIEWS),
     l'ombre n'est pas dans la photo : on la pose ici, en bas de l'encombrement
     à l'écran. Elle reste donc toujours SOUS le produit, y compris en paysage
     — une ombre incrustée dans la photo, elle, pivote avec le produit et se
     retrouve sur le côté. ---------------------------------------------- */
  function productHasCutout() {
    var p = state.selectedProduct;
    return !!(p && (CUTOUT_PREVIEWS[p.handle] || imageForme(p)));
  }

  /* Boîte de la silhouette réellement opaque du PNG, en coordonnées 0-1 et
     mesurée une seule fois. Les bords en dégradé laissés par le détourage ne
     doivent pas compter : sinon l'ombre se décolle du produit dès qu'il
     tourne. Repli sur l'image entière si le canvas n'est pas lisible. */
  function silhouetteBox(img) {
    if (img._bancoSil) return img._bancoSil;
    var box = { x0: 0, y0: 0, x1: 1, y1: 1 };
    try {
      var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
      var sc = Math.min(120 / nw, 120 / nh, 1);
      var w = Math.max(1, Math.round(nw * sc)), h = Math.max(1, Math.round(nh * sc));
      var oc = document.createElement('canvas');
      oc.width = w; oc.height = h;
      var octx = oc.getContext('2d');
      octx.drawImage(img, 0, 0, w, h);
      var d = octx.getImageData(0, 0, w, h).data;
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          if (d[(y * w + x) * 4 + 3] >= 128) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
      }
      if (x1 >= x0 && y1 >= y0) {
        box = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
      }
    } catch (e) { /* image non lisible : on garde le rectangle complet */ }
    img._bancoSil = box;
    return box;
  }

  /* Boîte du PRODUIT dans son packshot, en fractions 0-1, mesurée une fois.
     Les photos catalogue portent une large marge de studio : sans ce
     recadrage, la planche n'occupait que la moitié de l'aperçu et la gravure
     paraissait minuscule, alors qu'elle remplit bien l'article. */
  function boiteProduit(img) {
    if (img._bancoBoite) return img._bancoBoite;
    var box = { x0: 0, y0: 0, x1: 1, y1: 1 };
    try {
      var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
      var sc = Math.min(160 / nw, 160 / nh, 1);
      var w = Math.max(1, Math.round(nw * sc)), h = Math.max(1, Math.round(nh * sc));
      var oc = document.createElement('canvas');
      oc.width = w; oc.height = h;
      var octx = oc.getContext('2d', { willReadFrequently: true });
      octx.drawImage(img, 0, 0, w, h);
      var d = octx.getImageData(0, 0, w, h).data;
      /* fond de référence : la moyenne des quatre coins */
      var coins = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
      var fR = 0, fV = 0, fB = 0;
      coins.forEach(function (k) { fR += d[k]; fV += d[k + 1]; fB += d[k + 2]; });
      fR /= 4; fV /= 4; fB /= 4;
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var i = (y * w + x) * 4;
          if (d[i + 3] < 40) continue;
          var r = d[i], v = d[i + 1], b = d[i + 2];
          var mx = Math.max(r, v, b), mn = Math.min(r, v, b);
          var loin = (Math.abs(r - fR) + Math.abs(v - fV) + Math.abs(b - fB)) / 3 > 22;
          if (!loin || (mn > 224 && mx - mn < 24)) continue;
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
      /* la boîte doit rester crédible : sinon on garde l'image entière */
      if (x1 > x0 && y1 > y0 && (x1 - x0) > w * 0.15 && (y1 - y0) > h * 0.15) {
        box = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
      }
    } catch (e) { /* image non lisible : cadre complet */ }
    img._bancoBoite = box;
    return box;
  }

  /* `leve` (0 → 1) : hauteur dont l'article est soulevé pendant la bascule
     d'orientation. Une planche qu'on tourne quitte un instant la table —
     son ombre s'écarte, s'étale et pâlit, puis revient se resserrer. Sans ce
     souffle, la bascule donnait l'impression que l'ombre était peinte sur le
     décor. À 0 (aperçu fixe), le calcul est exactement celui d'avant. */
  function drawGroundShadow(c, img, dw, dh, angle, ox, oy, leve) {
    var box = silhouetteBox(img);
    var sw = (box.x1 - box.x0) * dw; /* taille de la silhouette à l'écran */
    var sh = (box.y1 - box.y0) * dh;
    if (ox === undefined) ox = ((box.x0 + box.x1) / 2 - 0.5) * dw; /* décentrage */
    if (oy === undefined) oy = ((box.y0 + box.y1) / 2 - 0.5) * dh;
    if (!leve) leve = 0;
    var cos = Math.cos(angle), sin = Math.sin(angle);
    var co = Math.abs(cos), si = Math.abs(sin);
    var bw = sw * co + sh * si; /* encombrement écran de la silhouette tournée */
    var bh = sw * si + sh * co;
    var rx = bw * 0.36 * (1 + 0.12 * leve);
    var ry = Math.max(5, bh * 0.035) * (1 + 0.22 * leve);
    var opac = 1 - 0.34 * leve;
    c.save();
    c.translate(
      CANVAS_W / 2 + (ox * cos - oy * sin),
      CANVAS_H / 2 + (ox * sin + oy * cos) + bh / 2 + ry * (0.5 + 0.55 * leve)
    );
    c.scale(rx, ry);
    var g = c.createRadialGradient(0, 0, 0, 0, 0, 1);
    g.addColorStop(0, 'rgba(26,26,24,' + (0.30 * opac).toFixed(3) + ')');
    g.addColorStop(0.5, 'rgba(26,26,24,' + (0.16 * opac).toFixed(3) + ')');
    g.addColorStop(1, 'rgba(26,26,24,0)');
    c.fillStyle = g;
    c.beginPath();
    c.arc(0, 0, 1, 0, Math.PI * 2);
    c.fill();
    c.restore();
  }

  /* Échelle et décentrage à appliquer pour qu'un produit — recadré sur
     lui-même — remplisse l'aperçu sous un angle donné. Sert à la fois à
     l'aperçu fixe et à chaque image de l'animation de rotation, pour qu'elles
     ne puissent pas diverger. */
  var REMPLISSAGE = 0.92;      /* part du canevas occupée par l'article */
  var REMPLISSAGE_OMBRE = 0.86; /* un peu moins quand il faut loger l'ombre */
  function poseProduit(img, angle) {
    var nw = img.naturalWidth || img.width;
    var nh = img.naturalHeight || img.height;
    var box = boiteProduit(img);
    var bw = (box.x1 - box.x0) * nw, bh = (box.y1 - box.y0) * nh;
    var co = Math.abs(Math.cos(angle)), si = Math.abs(Math.sin(angle));
    var ew = bw * co + bh * si; /* encombrement écran du cadre utile tourné */
    var eh = bw * si + bh * co;
    var part = productHasCutout() ? REMPLISSAGE_OMBRE : REMPLISSAGE;
    var sc = Math.min(CANVAS_W * part / ew, CANVAS_H * part / eh);
    return {
      sc: sc,
      /* décentrage du cadre utile dans l'image, en pixels d'écran */
      dx: ((box.x0 + box.x1) / 2 - 0.5) * nw * sc,
      dy: ((box.y0 + box.y1) / 2 - 0.5) * nh * sc,
      nw: nw, nh: nh
    };
  }

  function buildColorCanvas(img, rotated) {
    var off = makeLayerCanvas();
    var offCtx = off.getContext('2d');
    offCtx.fillStyle = '#f5f0ea';
    offCtx.fillRect(0, 0, CANVAS_W, CANVAS_H);
    var nw = img.naturalWidth || img.width;
    var nh = img.naturalHeight || img.height;
    if (!nw || !nh) return off;
    dessinerProduit(offCtx, img, rotated ? -Math.PI / 2 : 0);
    return off;
  }

  /* Dessine le produit centré sur son cadre utile, avec son ombre au sol. */
  function dessinerProduit(c, img, angle, leve) {
    var p = poseProduit(img, angle);
    if (productHasCutout()) {
      /* la silhouette du PNG et le cadre utile se confondent : une fois le
         cadre centré, l'ombre tombe pile sous l'article */
      var sb = silhouetteBox(img), bp = boiteProduit(img);
      var ox = ((sb.x0 + sb.x1) / 2 - (bp.x0 + bp.x1) / 2) * p.nw * p.sc;
      var oy = ((sb.y0 + sb.y1) / 2 - (bp.y0 + bp.y1) / 2) * p.nh * p.sc;
      drawGroundShadow(c, img, p.nw * p.sc, p.nh * p.sc, angle, ox, oy, leve);
    }
    c.save();
    c.translate(CANVAS_W / 2, CANVAS_H / 2);
    c.rotate(angle);
    c.drawImage(img,
      -p.nw * p.sc / 2 - p.dx, -p.nh * p.sc / 2 - p.dy,
      p.nw * p.sc, p.nh * p.sc);
    c.restore();
  }

  /* Le produit ne surgit pas : il monte en fondu, comme une photo qu'on pose.
     Sans cela, le passage de l'étape 1 à l'étape 2 se faisait par un à-coup. */
  var fondAnimId = null;
  function fondreProduit() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.productFade = 1;
      return;
    }
    state.productFade = 0;
    var depart = null;
    if (fondAnimId) cancelAnimationFrame(fondAnimId);
    fondAnimId = requestAnimationFrame(function pas(t) {
      if (depart === null) depart = t;
      var u = Math.min(1, (t - depart) / 420);
      state.productFade = 1 - Math.pow(1 - u, 3);
      renderCanvas();
      fondAnimId = u < 1 ? requestAnimationFrame(pas) : null;
    });
  }

  /* Résout et affiche le fond produit (avec rotation éventuelle), en
     s'appuyant sur les caches ; charge l'image si nécessaire. */
  function applyProductBackground(product, sansFondu) {
    var url = imageProduit(product);
    var key = url + (state.productRotated ? ':rot' : '');
    if (productImgCache[key]) {
      state.productBgCanvas = productImgCache[key];
      state.productBgReady = true;
      if (!sansFondu) fondreProduit();
      renderCanvas();
      return;
    }
    var raw = productRawImgCache[url];
    if (raw) {
      productImgCache[key] = buildColorCanvas(raw, state.productRotated);
      state.productBgCanvas = productImgCache[key];
      state.productBgReady = true;
      if (!sansFondu) fondreProduit();
      renderCanvas();
      return;
    }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      productRawImgCache[url] = img;
      applyProductBackground(product, sansFondu);
    };
    img.onerror = function () { loadProductFallback(url); };
    img.src = url;
  }

  /* --- ZONE GRAVABLE DU PRODUIT ------------------------------------------
     Mesurée sur la photo du produit affichée (voir BancoImageAnalysis) : le
     corps de l'article, moins une marge. La poignée de la planche et le vide
     autour en sont exclus, et la zone suit la rotation portrait/paysage. */
  var zoneCache = {};
  function zoneGravure() {
    var repli = {
      x: CANVAS_W * 0.30, y: CANVAS_H * 0.26,
      w: CANVAS_W * 0.40, h: CANVAS_H * 0.48
    };
    var p = state.selectedProduct;
    if (!p || !state.productBgCanvas || !window.BancoImageAnalysis) return repli;
    var key = imageProduit(p) + (state.productRotated ? ':rot' : '');
    if (!zoneCache[key]) {
      var f = window.BancoImageAnalysis.zoneGravable(state.productBgCanvas);
      zoneCache[key] = f
        ? { x: f.x * CANVAS_W, y: f.y * CANVAS_H, w: f.w * CANVAS_W, h: f.h * CANVAS_H }
        : repli;
    }
    return zoneCache[key];
  }

  /* --- PRÉSENTATION (pied / œillet) --------------------------------------
     Trois combinaisons, trois aperçus, trois variantes. Tout part d'ici : la
     clé courante sert de suffixe d'image, de nom de variante et d'étiquette
     sur la commande. ------------------------------------------------------ */
  function presentationCle() {
    if (state.presPied && state.presOeillet) return 'pied-oeillet';
    if (state.presPied) return 'pied';
    return state.presOeillet ? 'oeillet' : 'seule';
  }

  function aPresentation(product) {
    return !!(product && PRESENTATION_HANDLES.indexOf(product.handle) !== -1 &&
              PRESENTATION_RENDUS[presentationCle()] && presentationsFacturables(product));
  }

  /* Image réellement peinte dans l'aperçu : l'aperçu de la présentation quand
     le produit en a une, sa photo catalogue sinon. La grille de choix, elle,
     garde toujours la photo catalogue. */
  function imageProduit(product) {
    if (!product) return '';
    if (aPresentation(product)) return PRESENTATION_RENDUS[presentationCle()];
    return imageForme(product) || product.img;
  }

  /* La variante Shopify qui porte la présentation choisie — c'est elle qui
     applique le supplément des deux ensemble. */
  function variantePresentation(product) {
    var nom = PRESENTATION_VARIANTES[presentationCle()];
    if (!product || !product.variants || !nom) return null;
    var cible = nom.toLowerCase();
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].title).trim().toLowerCase() === cible) return product.variants[i];
    }
    return null;
  }

  /* Toutes les variantes du choix doivent être au rendez-vous : sans elles on
     ne saurait pas facturer le supplément, et mieux vaut ne rien proposer que
     de livrer un œillet sans l'avoir compté. */
  function presentationsFacturables(product) {
    return Object.keys(PRESENTATION_VARIANTES).every(function (cle) {
      var nom = PRESENTATION_VARIANTES[cle].toLowerCase();
      return (product && product.variants ? product.variants : []).some(function (v) {
        return String(v.title).trim().toLowerCase() === nom;
      });
    });
  }

  function updatePresentationControls(product) {
    var field = document.getElementById('banco-presentation-field');
    if (!field) return;
    var offert = !!(product && PRESENTATION_HANDLES.indexOf(product.handle) !== -1 &&
                    Object.keys(PRESENTATION_VARIANTES).every(function (c) {
                      return PRESENTATION_RENDUS[c];
                    }) && presentationsFacturables(product));
    field.style.display = offert ? '' : 'none';
    if (!offert) return;
    /* on repart toujours de la présentation la plus courante : l'œillet */
    state.presPied = false;
    state.presOeillet = true;
    var cp = document.getElementById('banco-pres-pied');
    var co = document.getElementById('banco-pres-oeillet');
    if (cp) cp.checked = false;
    if (co) co.checked = true;
    appliquerVariantePresentation(product);
    majPresentationInfos(product);
  }

  function appliquerVariantePresentation(product) {
    var v = variantePresentation(product);
    if (v) state.variantId = v.id;
  }

  /* Rappel du prix sous les cases : le client voit le supplément avant de
     cocher, pas au moment de payer. */
  function majPresentationInfos(product) {
    var hint = document.getElementById('banco-presentation-hint');
    if (!hint) return;
    var v = variantePresentation(product);
    var cle = presentationCle();
    var txt = cle === 'seule'
      ? 'Bûche seule, sans support ni attache.'
      : 'L\'aperçu suit votre choix.';
    /* le supplément ne s'annonce que quand il reste à venir : une seule des
       deux cases est prise, prendre l'autre coûtera quelque chose */
    if (cle === 'pied' || cle === 'oeillet') {
      var ici = prixDe(product, cle), deux = prixDe(product, 'pied-oeillet');
      if (ici != null && deux != null && deux > ici) {
        txt += ' Les deux ensemble : +' + formatEuros(deux - ici) + '.';
      }
    }
    if (v) txt += ' Total : ' + formatEuros(v.price) + '.';
    hint.textContent = txt;

    /* Sur chaque case non cochée : ce que la cocher ajouterait. Le client voit
       le supplément avant de cliquer, et du bon côté — cocher le pied quand
       l'œillet est déjà pris coûte autant que l'inverse. */
    majBadge(product, 'banco-pres-pied', cleAvec(true, state.presOeillet), state.presPied);
    majBadge(product, 'banco-pres-oeillet', cleAvec(state.presPied, true), state.presOeillet);
  }

  function cleAvec(pied, oeillet) {
    if (pied && oeillet) return 'pied-oeillet';
    if (pied) return 'pied';
    return oeillet ? 'oeillet' : 'seule';
  }

  function prixDe(product, cle) {
    var nom = (PRESENTATION_VARIANTES[cle] || '').toLowerCase();
    var trouve = null;
    (product && product.variants ? product.variants : []).forEach(function (v) {
      if (String(v.title).trim().toLowerCase() === nom) trouve = v.price;
    });
    return trouve;
  }

  function majBadge(product, idCase, cleSiCochee, dejaCochee) {
    var carte = document.querySelector('.banco-pres-carte[for="' + idCase + '"] .banco-pres-titre');
    if (!carte) return;
    var sup = carte.querySelector('.banco-pres-sup');
    var actuel = prixDe(product, presentationCle());
    var apres = prixDe(product, cleSiCochee);
    var ecart = (actuel != null && apres != null) ? apres - actuel : 0;
    if (dejaCochee || ecart <= 0) {
      if (sup) sup.remove();
      return;
    }
    if (!sup) {
      sup = document.createElement('span');
      sup.className = 'banco-pres-sup';
      carte.appendChild(sup);
    }
    sup.textContent = '+' + formatEuros(ecart);
  }

  /* Les éléments déjà posés suivent le produit : d'un aperçu à l'autre la
     bûche n'occupe pas tout à fait la même place — sans recalage, une photo
     centrée sur le bois se retrouvait à cheval sur l'écorce. */
  function recalerElements(avant, apres) {
    if (!avant || !apres || !avant.w || !avant.h) return;
    var sx = apres.w / avant.w, sy = apres.h / avant.h;
    var s = Math.min(sx, sy);
    if (Math.abs(s - 1) < 0.002 && Math.abs(apres.x - avant.x) < 0.5 &&
        Math.abs(apres.y - avant.y) < 0.5) return;
    state.elements.forEach(function (el) {
      el.x = apres.x + (el.x - avant.x) * sx;
      el.y = apres.y + (el.y - avant.y) * sy;
      if (el.type === 'text') {
        el.size = Math.max(8, Math.round(el.size * s));
      } else {
        el.w = Math.max(1, Math.round(el.w * s));
        el.h = Math.max(1, Math.round(el.h * s));
        el.sizePercent = Math.round(Math.max(el.w, el.h) / Math.min(CANVAS_W, CANVAS_H) * 100);
        el._bounds = null;
      }
    });
  }

  function setPresentation(pied, oeillet) {
    var product = state.selectedProduct;
    if (!product) return;
    if (state.presPied === pied && state.presOeillet === oeillet) return;

    var zoneAvant = aPresentation(product) ? zoneGravure() : null;
    state.presPied = pied;
    state.presOeillet = oeillet;
    appliquerVariantePresentation(product);
    applyProductBackground(product, true);
    if (zoneAvant) recalerElements(zoneAvant, zoneGravure());
    majPresentationInfos(product);
    renderCanvas();
  }

  /* --- FORME DU PRODUIT (rond / carré) -----------------------------------
     Le porte-clés existe en deux formes. Le choix fait trois choses d'un coup :
     il change l'aperçu gravé (chaque forme a son PNG détouré), il change la
     variante Shopify ajoutée au panier, et il recale les éléments déjà posés —
     la zone gravable d'un rond n'est pas celle d'un carré. ------------------ */
  /* Comparaison de titres de variante tolérante : « Carré », « carre » et
     « CARRÉ » désignent la même forme. L'atelier saisit les options à la main
     dans l'admin — une majuscule ou un accent oublié ne doit pas décrocher le
     bouton de sa variante. */
  function memeTitre(a, b) {
    function net(v) {
      v = String(v == null ? '' : v).trim().toLowerCase();
      return v.normalize ? v.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : v;
    }
    return net(a) === net(b);
  }

  function apercusForme(product) {
    return (product && FORME_APERCUS[product.handle]) || null;
  }

  /* L'aperçu de la forme courante, s'il existe. Il sert dès que le thème le
     fournit, même si les variantes ne sont pas encore créées : sans lui
     l'aperçu retomberait sur la photo catalogue, fond compris. */
  function imageForme(product) {
    var a = apercusForme(product);
    return a ? (a[state.forme] || a[Object.keys(a)[0]] || '') : '';
  }

  /* La variante Shopify qui porte la forme choisie — c'est elle qui part au
     panier, donc au bon prix et avec la bonne forme sur le bon de commande. */
  function varianteForme(product) {
    var nom = FORME_VARIANTES[state.forme];
    if (!product || !product.variants || !nom) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (memeTitre(product.variants[i].title, nom)) return product.variants[i];
    }
    return null;
  }

  /* Les deux formes doivent exister en variante : proposer un choix qu'on ne
     sait pas facturer, c'est graver un rond et encaisser un carré. */
  function formesFacturables(product) {
    return Object.keys(FORME_VARIANTES).every(function (cle) {
      return (product && product.variants ? product.variants : []).some(function (v) {
        return memeTitre(v.title, FORME_VARIANTES[cle]);
      });
    });
  }

  function aFormeChoisie(product) {
    var a = apercusForme(product);
    return !!(product && FORME_HANDLES.indexOf(product.handle) !== -1 && a &&
              Object.keys(FORME_VARIANTES).every(function (c) { return a[c]; }) &&
              formesFacturables(product));
  }

  function updateFormeControls(product) {
    var field = document.getElementById('banco-forme-field');
    if (!field) return;
    var offert = aFormeChoisie(product);
    field.style.display = offert ? '' : 'none';
    if (!offert) return;
    state.forme = 'carre';
    appliquerVarianteForme(product);
    setFormeButtons();
    majFormeInfos(product);
  }

  function appliquerVarianteForme(product) {
    var v = varianteForme(product);
    if (v) state.variantId = v.id;
  }

  function setFormeButtons() {
    var bc = document.getElementById('banco-forme-carre');
    var br = document.getElementById('banco-forme-rond');
    var rond = state.forme === 'rond';
    if (bc) { bc.classList.toggle('active', !rond); bc.setAttribute('aria-pressed', String(!rond)); }
    if (br) { br.classList.toggle('active', rond); br.setAttribute('aria-pressed', String(rond)); }
  }

  /* Le prix suit la forme : s'il change d'une forme à l'autre, le client le
     voit avant de choisir, pas au panier. */
  function majFormeInfos(product) {
    var hint = document.getElementById('banco-forme-hint');
    if (!hint) return;
    var v = varianteForme(product);
    var txt = 'L\'aperçu et l\'article suivent votre choix.';
    if (v) txt += ' Total : ' + formatEuros(v.price) + '.';
    hint.textContent = txt;
  }

  function setForme(cle) {
    var product = state.selectedProduct;
    if (!product || !FORME_VARIANTES[cle] || state.forme === cle) return;
    if (!aFormeChoisie(product)) return;

    var zoneAvant = zoneGravure();
    state.forme = cle;
    appliquerVarianteForme(product);
    applyProductBackground(product, true);
    recalerElements(zoneAvant, zoneGravure());
    setFormeButtons();
    majFormeInfos(product);
    renderCanvas();
  }

  function updateOrientationControls(product) {
    var field = document.getElementById('banco-orientation-field');
    if (!field) return;
    var rotatable = product && ROTATABLE_HANDLES.indexOf(product.handle) !== -1;
    field.style.display = rotatable ? '' : 'none';
    setOrientationButtons();
  }

  function setOrientationButtons() {
    var bp = document.getElementById('banco-orient-portrait');
    var bl = document.getElementById('banco-orient-paysage');
    if (bp) { bp.classList.toggle('active', !state.productRotated); bp.setAttribute('aria-pressed', String(!state.productRotated)); }
    if (bl) { bl.classList.toggle('active', state.productRotated); bl.setAttribute('aria-pressed', String(state.productRotated)); }
  }

  /* --- Animation de bascule portrait/paysage --------------------------
     Le produit pivote de 90° dans l'aperçu (≈ 0,55 s, ease-in-out) en se
     rétractant légèrement à mi-course pour ne jamais déborder du cadre —
     comme une planche qu'on tourne sur la table. --------------------- */
  var orientAnimId = null;
  var orientAngle = 0; /* angle actuellement affiché (radians) */
  var orientFrameCanvas = null;

  function buildRotatedFrame(img, angle, leve) {
    if (!orientFrameCanvas) orientFrameCanvas = makeLayerCanvas();
    var c = orientFrameCanvas.getContext('2d');
    c.clearRect(0, 0, CANVAS_W, CANVAS_H);
    c.fillStyle = '#f5f0ea';
    c.fillRect(0, 0, CANVAS_W, CANVAS_H);
    if (!(img.naturalWidth || img.width)) return orientFrameCanvas;
    /* même pose que l'aperçu fixe : à la fin de l'animation, l'image ne
       « saute » pas d'une échelle à l'autre */
    dessinerProduit(c, img, angle, leve);
    return orientFrameCanvas;
  }

  function animateOrientation(img, targetAngle) {
    if (orientAnimId) { cancelAnimationFrame(orientAnimId); orientAnimId = null; }
    var fromAngle = orientAngle;
    var start = null;
    var D = 550;
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / D);
      orientAngle = fromAngle + (targetAngle - fromAngle) * ease(t);
      /* soulèvement en cloche : nul aux deux extrémités, maximal à mi-course,
         pour que l'ombre parte et revienne sans marche d'escalier */
      state.productBgCanvas = buildRotatedFrame(img, orientAngle, Math.sin(Math.PI * t));
      state.productBgReady = true;
      renderCanvas();
      if (t < 1) {
        orientAnimId = requestAnimationFrame(frame);
      } else {
        orientAnimId = null;
        orientAngle = targetAngle;
        if (state.selectedProduct) applyProductBackground(state.selectedProduct, true);
      }
    }
    orientAnimId = requestAnimationFrame(frame);
    /* filet de sécurité : onglet masqué ou rAF gelé → basculer sans animation
       pour que l'aperçu soit toujours dans le bon sens */
    setTimeout(function () {
      if (start === null && orientAnimId) {
        cancelAnimationFrame(orientAnimId);
        orientAnimId = null;
        orientAngle = targetAngle;
        if (state.selectedProduct) applyProductBackground(state.selectedProduct, true);
      }
    }, 200);
  }

  function setOrientation(rotated) {
    if (state.productRotated === rotated) return;
    state.productRotated = rotated;
    setOrientationButtons();
    if (!state.selectedProduct) return;
    var raw = productRawImgCache[imageProduit(state.selectedProduct)];
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!raw || reduced) {
      orientAngle = rotated ? -Math.PI / 2 : 0;
      applyProductBackground(state.selectedProduct, true);
      return;
    }
    animateOrientation(raw, rotated ? -Math.PI / 2 : 0);
  }

  // --- CANVAS RENDERING ---

  /* Ajuste le nombre de pixels du canvas à ce que l'écran affiche réellement :
     largeur occupée par l'aperçu × densité de l'écran. Le repère de dessin
     reste 560×420 (setTransform), donc positions, clics et propriétés envoyées
     à l'atelier ne changent pas d'un pouce. Renvoie true si la finesse a
     changé — les fonds produit, composés à cette finesse, sont alors à refaire.
     Plafond à 3 : au-delà on paierait de la mémoire sans rien voir. */
  function applyCanvasResolution() {
    if (!ctx) return false;
    var dpr = window.devicePixelRatio || 1;
    var cssW = canvas.getBoundingClientRect().width;
    if (!cssW) cssW = Math.min(720, CANVAS_W); /* modale encore masquée */
    /* arrondi au quart pour ne pas tout recomposer au moindre pixel de large */
    var next = Math.max(1, Math.min(3, Math.round((cssW / CANVAS_W) * dpr * 4) / 4));
    if (next === PX && canvas.width === Math.round(CANVAS_W * PX)) return false;
    PX = next;
    canvas.width = Math.round(CANVAS_W * PX);
    canvas.height = Math.round(CANVAS_H * PX);
    ctx.setTransform(PX, 0, 0, PX, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    productImgCache = {};   /* composés à l'ancienne finesse */
    orientFrameCanvas = null;
    return true;
  }

  /* Canvas hors écran au même repère 560×420 que l'aperçu, mais avec autant de
     pixels que lui : dessiné ensuite pixel pour pixel, sans ré-échantillonnage. */
  function makeLayerCanvas() {
    var off = document.createElement('canvas');
    off.width = Math.round(CANVAS_W * PX);
    off.height = Math.round(CANVAS_H * PX);
    var c = off.getContext('2d');
    c.setTransform(PX, 0, 0, PX, 0, 0);
    c.imageSmoothingEnabled = true;
    c.imageSmoothingQuality = 'high';
    return off;
  }

  function renderCanvas() {
    if (!ctx) return;
    ctx.clearRect(0, 0, CANVAS_W, CANVAS_H);

    if (state.productBgCanvas && state.productBgReady) {
      var f = state.productFade === undefined ? 1 : state.productFade;
      try {
        if (f >= 1) {
          ctx.drawImage(state.productBgCanvas, 0, 0, CANVAS_W, CANVAS_H);
        } else {
          /* fondu d'arrivée : opacité + un souffle d'échelle, rien de plus */
          var z = 0.985 + 0.015 * f;
          ctx.save();
          ctx.globalAlpha = f;
          ctx.translate(CANVAS_W / 2, CANVAS_H / 2);
          ctx.scale(z, z);
          ctx.drawImage(state.productBgCanvas, -CANVAS_W / 2, -CANVAS_H / 2, CANVAS_W, CANVAS_H);
          ctx.restore();
        }
      }
      catch (e) { ctx.fillStyle = '#e8e0d0'; ctx.fillRect(0, 0, CANVAS_W, CANVAS_H); }
    } else if (state.productBgImg) {
      var bgI = state.productBgImg;
      var nw = bgI.naturalWidth || bgI.width;
      var nh = bgI.naturalHeight || bgI.height;
      ctx.fillStyle = '#f5f0ea'; ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);
      if (nw && nh) {
        var sc = Math.min(CANVAS_W / nw, CANVAS_H / nh);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        try { ctx.drawImage(bgI, (CANVAS_W - nw*sc)/2, (CANVAS_H - nh*sc)/2, nw*sc, nh*sc); } catch(e){}
      }
    } else {
      ctx.fillStyle = '#e8e0d0'; ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);
      ctx.fillStyle = '#bbb'; ctx.font = '15px Arial, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Aperçu du produit', CANVAS_W/2, CANVAS_H/2);
      ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    }

    state.elements.forEach(function (el) {
      if (el.type === 'text') drawText(el);
      else if (el.type === 'image') drawLayerImage(el);
    });
  }

  function drawText(el) {
    ctx.save();
    ctx.font = buildFontStr(el);
    /* gravure : brun brûlé fondu dans le bois (multiply) + léger relief */
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = '#2b180c';
    ctx.shadowColor = 'rgba(0,0,0,0.25)';
    ctx.shadowBlur = 1;
    ctx.shadowOffsetY = 0.7;
    ctx.textBaseline = 'top';
    var lines = el.text.split('\n');
    var lineH = el.size * 1.28;
    var maxW = 0;
    lines.forEach(function (line) { var w = ctx.measureText(line).width; if (w > maxW) maxW = w; });
    lines.forEach(function (line, i) { ctx.fillText(line, el.x, el.y + i * lineH); });
    ctx.restore();
    el._bounds = { x: el.x - 4, y: el.y - 4, w: maxW + 8, h: lines.length * lineH + 8 };
    if (state.selectedId === el.id) {
      drawSelectionBox(el._bounds);
      el._handles = { del: { x: el._bounds.x + el._bounds.w, y: el._bounds.y } };
      drawHandle(el._handles.del.x, el._handles.del.y, 'del');
    }
  }

  function drawLayerImage(el) {
    var engraved = el._engraving || el._bwCanvas;
    /* « Voir la photo originale » montre bien la photo du client — et non la
       source de travail : sur un logo, celle-ci est devenue une carte d'encre
       en noir et blanc, que personne ne reconnaîtrait. */
    var layer = el.showOriginal ? (el._imgOriginal || el._imgEl) : engraved;
    if (!layer || !el.w || !el.h) return;
    var revealT = el._reveal ? el._reveal.t : 1;
    var rot = (el.rotation || 0) * Math.PI / 180;
    var cx = el.x + el.w / 2, cy = el.y + el.h / 2;

    function drawRotated(what, alpha, multiply) {
      ctx.save();
      if (el._reveal && !el.showOriginal) {
        ctx.beginPath();
        ctx.rect(el.x - 4, el.y - 4, el.w + 8, (el.h + 8) * revealT);
        ctx.clip();
      }
      if (alpha < 1) ctx.globalAlpha = alpha;
      if (multiply) {
        ctx.globalCompositeOperation = 'multiply';
        ctx.shadowColor = 'rgba(0,0,0,0.28)';
        ctx.shadowBlur = 1.2;
        ctx.shadowOffsetY = 0.8;
      }
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      /* la photo originale n'a pas forcément le format de la gravure (le
         détourage recadre sur le sujet) : on la loge sans la déformer */
      var dw = el.w, dh = el.h;
      var nw = what.naturalWidth || what.width, nh = what.naturalHeight || what.height;
      if (nw && nh) {
        var f = Math.min(el.w / nw, el.h / nh);
        dw = nw * f; dh = nh * f;
      }
      ctx.drawImage(what, -dw / 2, -dh / 2, dw, dh);
      ctx.restore();
    }

    try {
      /* pendant le scan : fantôme de la photo (déjà détourée) qui s'efface
         très vite sous la gravure — assez pour lire « photo → gravure », pas
         assez pour que la version couleur s'installe à l'écran */
      if (!el.showOriginal && el._reveal && el._imgEl) {
        ctx.save();
        ctx.globalAlpha = Math.max(0, 0.5 - revealT * 1.2);
        ctx.drawImage(el._imgEl, el.x, el.y, el.w, el.h);
        ctx.restore();
      }

      if (!el.showOriginal && el._engraving) {
        /* passe 1 : corps des brûlures (le bois carbonisé masque le veinage),
           passe 2 : multiply + relief (le veinage transparaît dans les clairs) */
        drawRotated(el._engraving, 0.3, false);
        drawRotated(layer, 1, true);
      } else {
        drawRotated(layer, 1, false);
      }

      /* Ligne laser incandescente pendant le scan, avec la traînée de braise
         qui reste derrière elle : c'est ce que l'on voit sur la machine, le
         bois continue de rougeoyer une fraction de seconde après le passage
         de la tête. */
      if (el._reveal && !el.showOriginal && revealT < 1) {
        var ly = el.y + el.h * revealT;
        ctx.save();
        var traine = Math.min(46, el.h * 0.22);
        if (traine > 2) {
          var braise = ctx.createLinearGradient(el.x, ly - traine, el.x, ly);
          braise.addColorStop(0, 'rgba(214,106,32,0)');
          braise.addColorStop(1, 'rgba(255,150,52,0.30)');
          ctx.globalCompositeOperation = 'lighter';
          ctx.fillStyle = braise;
          ctx.fillRect(el.x, ly - traine, el.w, traine);
          ctx.globalCompositeOperation = 'source-over';
        }
        var grad = ctx.createLinearGradient(el.x, ly - 7, el.x, ly + 7);
        grad.addColorStop(0, 'rgba(255,190,90,0)');
        grad.addColorStop(0.5, 'rgba(255,220,150,0.95)');
        grad.addColorStop(1, 'rgba(255,190,90,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(el.x, ly - 7, el.w, 14);
        /* cœur du faisceau : un trait fin presque blanc, qui vibre à peine */
        var vibre = 0.9 + 0.1 * Math.sin(revealT * 90);
        ctx.fillStyle = 'rgba(255,248,228,' + vibre.toFixed(2) + ')';
        ctx.fillRect(el.x, ly - 0.9, el.w, 1.8);
        ctx.restore();
      }
    } catch (e) { return; }

    /* englobant du rectangle tourné (sélection + drag) */
    var co = Math.abs(Math.cos(rot)), si = Math.abs(Math.sin(rot));
    var bw = el.w * co + el.h * si, bh = el.w * si + el.h * co;
    el._bounds = { x: cx - bw / 2 - 3, y: cy - bh / 2 - 3, w: bw + 6, h: bh + 6 };
    if (state.selectedId === el.id) {
      drawSelectionBox(el._bounds);
      /* poignées de manipulation directe : supprimer, tourner, redimensionner */
      el._handles = {
        del:    { x: el._bounds.x + el._bounds.w, y: el._bounds.y },
        rotate: { x: el._bounds.x, y: el._bounds.y },
        resize: { x: el._bounds.x + el._bounds.w, y: el._bounds.y + el._bounds.h }
      };
      drawHandle(el._handles.del.x, el._handles.del.y, 'del');
      drawHandle(el._handles.rotate.x, el._handles.rotate.y, 'rotate');
      drawHandle(el._handles.resize.x, el._handles.resize.y, 'resize');
    }
  }

  function drawSelectionBox(b) {
    ctx.save();
    ctx.strokeStyle = '#1A1A18'; ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 4]); ctx.strokeRect(b.x, b.y, b.w, b.h);
    ctx.setLineDash([]);
    ctx.restore();
  }

  /* Poignées blanches cerclées de noir, pictos vectoriels — façon Canva */
  function drawHandle(x, y, type) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(x, y, HANDLE_R, 0, Math.PI * 2);
    ctx.fillStyle = '#ffffff';
    ctx.shadowColor = 'rgba(26,26,24,0.25)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetY = 1;
    ctx.fill();
    ctx.shadowColor = 'transparent';
    ctx.lineWidth = 1.3;
    ctx.strokeStyle = '#1A1A18';
    ctx.stroke();
    ctx.lineWidth = 1.6;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (type === 'del') {
      ctx.beginPath();
      ctx.moveTo(x - 3.1, y - 3.1); ctx.lineTo(x + 3.1, y + 3.1);
      ctx.moveTo(x + 3.1, y - 3.1); ctx.lineTo(x - 3.1, y + 3.1);
      ctx.stroke();
    } else if (type === 'resize') {
      ctx.beginPath();
      ctx.moveTo(x - 2.4, y - 2.4); ctx.lineTo(x + 2.4, y + 2.4);
      ctx.moveTo(x - 4, y - 1); ctx.lineTo(x - 4, y - 4); ctx.lineTo(x - 1, y - 4);
      ctx.moveTo(x + 4, y + 1); ctx.lineTo(x + 4, y + 4); ctx.lineTo(x + 1, y + 4);
      ctx.stroke();
    } else { /* rotate */
      ctx.beginPath();
      ctx.arc(x, y, 3.8, -0.4 * Math.PI, 1.05 * Math.PI);
      ctx.stroke();
      ctx.fillStyle = '#1A1A18';
      ctx.beginPath();
      ctx.moveTo(x + 4.9, y - 3.6);
      ctx.lineTo(x + 1.6, y - 4.2);
      ctx.lineTo(x + 4.1, y - 0.7);
      ctx.closePath();
      ctx.fill();
    }
    ctx.restore();
  }

  function handleAt(el, x, y) {
    if (!el || !el._handles || state.selectedId !== el.id) return null;
    var r = HANDLE_R + 4;
    for (var k in el._handles) {
      var h = el._handles[k];
      var dx = x - h.x, dy = y - h.y;
      if (dx * dx + dy * dy <= r * r) return k;
    }
    return null;
  }

  function buildFontStr(el) {
    return (el.italic ? 'italic ' : '') + (el.bold ? 'bold ' : '') + el.size + 'px ' + el.font;
  }

  // --- BACKGROUND REMOVAL ---

  /* L'import dynamique passe par new Function : Shopify minifie les assets avec
     esbuild, qui réécrit un `import(...)` littéral en `require(...)` — inconnu
     du navigateur (« require is not defined »), ce qui cassait tout le
     détourage en ligne. Le code dans la chaîne échappe à cette réécriture. */
  var dynamicImport = new Function('url', 'return import(url);');

  function loadBgRemoval() {
    if (bgRemovalModule) return Promise.resolve(bgRemovalModule);
    installBgFetchCache();
    return dynamicImport(BG_REMOVAL_CDN).then(function (mod) { bgRemovalModule = mod; return mod; });
  }

  /* Le modèle (une dizaine de Mo, servi en nombreux fragments) est le poste de
     loin le plus lent. On le télécharge dès l'ouverture du configurateur —
     pendant que le client choisit son article — pour qu'il soit prêt au moment
     de l'import. Respecte le mode économiseur de données. */
  var bgPreloadPromise = null;
  var bgModelReady = false; /* modèle en mémoire : les détourages suivants sont rapides */
  function preloadBgRemoval() {
    if (bgPreloadPromise) return bgPreloadPromise;
    var c = navigator.connection;
    if (c && (c.saveData || /^(slow-)?2g$/.test(c.effectiveType || ''))) return null;
    bgPreloadPromise = loadBgRemoval()
      .then(function (mod) { return mod.preload && mod.preload({ model: BG_MODEL }); })
      .then(function () { bgModelReady = true; syncBgUI(); })
      .catch(function (err) { console.warn('[BANCO] Préchargement IA ignoré :', err); });
    return bgPreloadPromise;
  }

  /* --- VOILE DE PRÉPARATION DE LA PHOTO -------------------------------------
     Le client ne voit sa photo sur le produit qu'une fois détourée ET convertie
     en gravure noir & blanc : entre l'import et ce moment-là, l'aperçu est
     couvert par un voile qui dit précisément où en est le traitement. Sans lui,
     il ne se passait visiblement rien pendant plusieurs secondes.

     Étapes : 1 lecture · 2 détourage IA (téléchargement du modèle compris) ·
     3 conversion gravure · 4 mise en place.

     Refonte du 08/08/2026 : la progression n'est plus un chiffre posé dans une
     barre, c'est UNE valeur (--p, 0 → 100) interpolée image par image, qui
     pilote à la fois la gravure de la miniature, la tête laser et le rail. Elle
     n'attend pas les nouvelles du calcul pour bouger : faute de nouvelle, elle
     rampe vers le haut du segment en cours, de plus en plus lentement. Un voile
     qui se fige, c'est un client qui croit à un plantage.

     Correctif du 29/08/2026 : la barre ne suivait plus les quatre phases. Les
     appelants annonçaient un POURCENTAGE DU RAIL entier, chacun avec ses
     propres chiffres, et plusieurs sortaient de leur étape — la 2e passe du
     détourage annonçait 80 puis 92 % (segments 3 et 4) sous le libellé
     « Détourage du sujet par l'IA », et les étapes 3 et 4, soit 22 % du rail,
     se remplissaient en 120 ms sans que personne les voie. `setProcessingUI`
     reçoit désormais l'avancement DANS l'étape (0 → 1) et déduit le
     pourcentage des bornes : un segment ne peut plus se remplir hors de sa
     phase, et chaque phase a sa propre durée. */
  var LOADER_ETAPES = {
    1: 'Lecture de votre photo',
    2: 'Détourage du sujet par l\'IA',
    3: 'Conversion en gravure noir & blanc',
    4: 'Mise en place sur le produit'
  };
  var LOADER_DETAIL = {
    1: 'Ouverture du fichier…',
    2: 'Le sujet est isolé de son décor',
    3: 'Passage en noir & blanc de gravure',
    /* rien à ajouter à l'étape 4 : le titre annonce déjà « c'est prêt ». La
       ligne reste disponible pour un message d'échec du détourage. */
    4: ''
  };
  var LOADER_TITRE = 'Nous préparons votre gravure';
  var LOADER_TITRE_FIN = 'Votre gravure est prête';
  /* Part du rail attribuée à chaque étape. Les bornes suivent les pourcentages
     déjà annoncés par le reste du fichier (18 → 82 → 100) : un segment plein
     veut dire « cette étape est franchie », jamais « ça avance bien ». */
  var LOADER_BORNES = [[0, 16], [16, 78], [78, 92], [92, 100]];
  /* Découpage INTERNE de l'étape 2, en fraction de son propre segment :
     téléchargement du modèle, 1re passe de l'IA, 2e passe. Tout ce qui est
     annoncé pendant le détourage reste ainsi dans le segment 2 — c'est ce qui
     manquait : la 2e passe annonçait « 80 à 92 % » du rail entier et remplissait
     les segments 3 et 4 sous le libellé « Détourage du sujet par l'IA ». */
  var BG_PART_MODELE = 0.55;
  var BG_PASSE1 = [0.58, 0.80];
  var BG_PASSE2 = [0.80, 0.97];

  var loaderThumbUrl = null;
  var loaderClearTimer = null;
  var loaderStep = 1;     /* étape en cours (1 → 4) */
  var loaderP = 0;        /* progression affichée */
  var loaderCible = 0;    /* progression annoncée par le traitement */
  var loaderPlafond = 0;  /* jusqu'où la reptation a le droit d'aller */
  var loaderFini = false;
  var loaderRaf = null;

  function mouvementReduit() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function appliquerProgression(box, p) {
    box.style.setProperty('--p', p.toFixed(2));
    var segs = box.querySelectorAll('.banco-loader-seg');
    /* le segment « vivant » est celui que la progression est en train de
       remplir — la progression affichée retarde sur l'annonce, la pointe chaude
       reste donc sur le segment réellement en cours de remplissage. Elle ne
       peut en revanche jamais DÉPASSER l'étape annoncée : sinon, à l'instant
       où un segment se remplit tout à fait, la pointe sautait au segment
       suivant alors que le libellé annonçait encore l'étape précédente. */
    var vivant = -1;
    for (var i = 0; i < segs.length; i++) {
      var b = LOADER_BORNES[i] || LOADER_BORNES[3];
      var f = Math.max(0, Math.min(1, (p - b[0]) / (b[1] - b[0])));
      var barre = segs[i].firstElementChild;
      if (barre) barre.style.setProperty('--f', f.toFixed(3));
      if (vivant === -1 && f < 1) vivant = i;
    }
    if (vivant > loaderStep - 1) vivant = loaderStep - 1;
    for (var j = 0; j < segs.length; j++) {
      segs[j].classList.toggle('is-live', !loaderFini && j === vivant);
    }
    var pctEl = document.getElementById('banco-loader-pct');
    if (pctEl) pctEl.textContent = Math.round(p) + ' %';
  }

  function tweenLoader() {
    loaderRaf = null;
    var box = document.getElementById('banco-photo-loader');
    if (!box || !box.classList.contains('visible')) return;
    /* reptation : sans nouvelle du calcul, on avance quand même vers le haut du
       segment, de moins en moins vite — asymptote, jamais de dépassement */
    if (!loaderFini && loaderCible < loaderPlafond) {
      loaderCible += (loaderPlafond - loaderCible) * 0.0016;
    }
    /* une fois le calcul terminé, le voile ne reste affiché qu'une demi-seconde :
       la barre doit atteindre 100 % avant de disparaître, sinon elle se referme
       sur un « 94 % » qui ressemble à un abandon */
    var ecart = loaderCible - loaderP;
    /* Plus la barre est loin de l'annonce, plus elle rattrape vite. À taux fixe,
       une étape expédiée (détourage instantané, modèle déjà en mémoire) laissait
       le rail traverser tout un segment APRÈS coup : mesuré le 29/08/2026, le
       rail affichait 52 % — donc le segment 2 — sous le libellé « Mise en place
       sur le produit ». La barre et les quatre phases se contredisaient. */
    loaderP += ecart * (loaderFini ? 0.26 : Math.min(0.40, 0.12 + Math.abs(ecart) * 0.004));
    /* Plancher : la progression affichée ne reste jamais dans un segment que le
       libellé a déjà quitté. C'est la garantie dure que le rail et l'étape
       annoncée désignent toujours le même segment. */
    var plancher = (LOADER_BORNES[loaderStep - 1] || LOADER_BORNES[3])[0];
    if (loaderP < plancher) loaderP += (plancher - loaderP) * 0.30;
    if (Math.abs(loaderCible - loaderP) < 0.05) loaderP = loaderCible;
    appliquerProgression(box, loaderP);
    loaderRaf = requestAnimationFrame(tweenLoader);
  }

  function relancerTween() {
    var box = document.getElementById('banco-photo-loader');
    if (!box) return;
    if (mouvementReduit()) {
      loaderP = loaderCible;
      appliquerProgression(box, loaderP);
      return;
    }
    if (!loaderRaf) loaderRaf = requestAnimationFrame(tweenLoader);
  }

  /* Remplacement d'une ligne de texte : l'ancienne s'échappe vers le haut en se
     floutant, la nouvelle monte depuis le bas. Un texte qui change d'un coup se
     lit comme un clignotement ; celui-ci se lit comme une progression. */
  function remplacerTexte(el, txt) {
    if (!el) return;
    txt = txt || '';
    if (el.dataset.txt === txt) return;
    el.dataset.txt = txt;
    if (!el.animate || mouvementReduit()) { el.textContent = txt; return; }

    /* BUG CORRIGÉ LE 29/08/2026 — le libellé restait bloqué sur « Lecture de
       votre photo » pendant TOUT le traitement, ce qui donnait un voile dont le
       texte ne correspondait plus du tout à la barre.

       Cause : le texte n'était écrit que dans le `onfinish` de la sortie. Deux
       libellés qui s'enchaînaient en moins de 160 ms — la durée de cette sortie
       — se perdaient donc : le second appel annulait la sortie du premier, et
       `cancel()` ne déclenche PAS `onfinish`. Le texte n'était jamais posé.
       Pire, `dataset.txt` était déjà à jour : plus aucun appel ultérieur ne
       rattrapait le coup, le libellé restait figé jusqu'à la fin.

       Correctif : le texte visé est mémorisé sur l'élément (`_txtVise`) et relu
       au moment de le poser. Une sortie déjà en cours n'est plus relancée — on
       la laisse finir, elle posera le texte le PLUS RÉCENT. Et un filet de
       sécurité pose le texte sans effet si l'animation n'a jamais pu se
       terminer (onglet passé en arrière-plan, fil principal saturé par l'IA). */
    el._txtVise = txt;
    if (el._sortie) return;
    if (el._anim) { try { el._anim.cancel(); } catch (e) {} el._anim = null; }

    /* Rien d'affiché pour l'instant : on écrit SANS attendre. Faire sortir une
       ligne vide ne montre rien, et si le fil principal se bloque avant la fin
       de cette sortie (l'IA le bloque plusieurs secondes) le client reste
       devant une ligne VIDE — c'est ce qu'a montré la capture du 30/08/2026 :
       un voile sans aucun texte pendant tout le détourage. */
    if (!el.textContent) {
      el.textContent = txt;
      el._anim = el.animate(
        [{ opacity: 0, transform: 'translateY(7px)', filter: 'blur(4px)' },
         { opacity: 1, transform: 'none', filter: 'blur(0px)' }],
        { duration: 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      return;
    }

    var sortie = el.animate(
      [{ opacity: 1, transform: 'none', filter: 'blur(0px)' },
       { opacity: 0, transform: 'translateY(-7px)', filter: 'blur(4px)' }],
      { duration: 160, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' });
    el._anim = sortie;
    el._sortie = sortie;

    clearTimeout(el._txtSecours);
    el._txtSecours = setTimeout(function () {
      if (el._sortie !== sortie) return;
      el._sortie = null;
      el.textContent = el._txtVise;
    }, 700);

    sortie.onfinish = function () {
      clearTimeout(el._txtSecours);
      el._sortie = null;
      el.textContent = el._txtVise;
      /* l'entrée est lancée AVANT l'annulation de la sortie : les deux sont
         appliquées dans le même calcul de style, donc aucun clignotement */
      el._anim = el.animate(
        [{ opacity: 0, transform: 'translateY(7px)', filter: 'blur(4px)' },
         { opacity: 1, transform: 'none', filter: 'blur(0px)' }],
        { duration: 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      try { sortie.cancel(); } catch (e) {}
    };
  }

  /* Remise à neuf d'une ligne de texte entre deux imports : sans elle, une
     sortie encore en cours (ou son filet de sécurité) réécrivait le texte du
     traitement PRÉCÉDENT par-dessus celui qui vient de commencer. */
  function reinitTexte(el, txt) {
    if (!el) return;
    clearTimeout(el._txtSecours);
    if (el._anim) { try { el._anim.cancel(); } catch (e) {} }
    el._anim = null;
    el._sortie = null;
    el._txtVise = txt || '';
    el.dataset.txt = txt || '';
    el.textContent = txt || '';
  }

  /* --- LE FIL PRINCIPAL EST BLOQUÉ PENDANT LE CALCUL -----------------------
     L'inférence de l'IA fige le fil principal plusieurs secondes (mesuré : 9 s
     sur un portrait, 17 s sur une photo de famille). Pendant ce temps NI
     `requestAnimationFrame`, NI les Web Animations, NI les `setTimeout` ne
     tournent. Conséquence, constatée sur la capture du 30/08/2026 : tout ce qui
     n'a pas été PEINT avant l'appel reste invisible jusqu'à la fin du calcul.
     Le voile montrait donc une barre arrêtée dans le premier segment et pas une
     seule ligne de texte, alors que l'étape 2 avait bien été annoncée.

     D'où trois précautions à prendre AVANT toute opération bloquante. */

  /* 1. la barre se place à la valeur annoncée sans attendre le lissage — qui,
        lui, ne tournera pas pendant le calcul */
  function snapProgression() {
    var box = document.getElementById('banco-photo-loader');
    if (!box) return;
    loaderP = loaderCible;
    appliquerProgression(box, loaderP);
  }

  /* 2. les textes en cours de remplacement sont posés immédiatement, plutôt que
        d'attendre un `onfinish` qui n'arrivera qu'après le calcul */
  function finirTextes() {
    ['banco-loader-title', 'banco-loader-step-label', 'banco-loader-detail']
      .forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || !el._sortie) return;
        clearTimeout(el._txtSecours);
        try { el._sortie.cancel(); } catch (e) {}
        el._sortie = null;
        el._anim = null;
        el.textContent = el._txtVise || '';
      });
  }

  /* 3. on rend la main au navigateur le temps d'une image, pour qu'il AFFICHE
        l'étape en cours avant de se figer dessus */
  function attendrePeinture() {
    return new Promise(function (ok) {
      if (!window.requestAnimationFrame) { setTimeout(ok, 40); return; }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { setTimeout(ok, 0); });
      });
    });
  }

  /* Les trois d'un coup : à appeler juste avant de bloquer le fil. */
  function figerProprement() {
    snapProgression();
    finirTextes();
    return attendrePeinture();
  }

  function openPhotoLoader(file) {
    var box = document.getElementById('banco-photo-loader');
    if (!box) return;
    clearTimeout(loaderClearTimer);
    var brut = document.getElementById('banco-loader-thumb');
    var grave = document.getElementById('banco-loader-thumb-grave');
    if (file) {
      if (loaderThumbUrl) URL.revokeObjectURL(loaderThumbUrl);
      loaderThumbUrl = URL.createObjectURL(file);
      if (brut) brut.src = loaderThumbUrl;
      if (grave) grave.src = loaderThumbUrl;
    }
    loaderP = 0;
    loaderCible = 0;
    loaderStep = 1;
    bgProgressLast = 0;
    loaderPlafond = LOADER_BORNES[0][1] - 1;
    loaderFini = false;
    appliquerProgression(box, 0);
    /* on repart sur le texte de l'étape 1, jamais sur du vide : une ligne vide
       est ce que le client voit si le fil se bloque avant le remplacement */
    reinitTexte(document.getElementById('banco-loader-detail'), LOADER_DETAIL[1]);
    reinitTexte(document.getElementById('banco-loader-step-label'), LOADER_ETAPES[1]);
    reinitTexte(document.getElementById('banco-loader-title'), LOADER_TITRE);
    box.classList.remove('is-done', 'is-leaving', 'is-indeterminate');
    var railInit = document.getElementById('banco-loader-rail');
    if (railInit) railInit.classList.remove('is-indeterminate');
    box.classList.add('visible');
    box.setAttribute('aria-hidden', 'false');
    relancerTween();
  }

  function closePhotoLoader() {
    var box = document.getElementById('banco-photo-loader');
    if (!box) return;
    var etaitVisible = box.classList.contains('visible');
    /* le voile part sur une gravure achevée, pas sur une barre à mi-course */
    if (loaderFini) { loaderP = loaderCible = 100; appliquerProgression(box, 100); }
    if (etaitVisible) fuiteDuVoile(box);
    box.classList.remove('visible');
    if (etaitVisible) box.classList.add('is-leaving');
    box.setAttribute('aria-hidden', 'true');
    if (loaderRaf) { cancelAnimationFrame(loaderRaf); loaderRaf = null; }
    /* la miniature n'est libérée qu'une fois le fondu terminé, sinon le voile
       se vide sous les yeux du client pendant qu'il disparaît */
    clearTimeout(loaderClearTimer);
    loaderClearTimer = setTimeout(function () {
      var brut = document.getElementById('banco-loader-thumb');
      var grave = document.getElementById('banco-loader-thumb-grave');
      if (brut) brut.removeAttribute('src');
      if (grave) grave.removeAttribute('src');
      if (loaderThumbUrl) { URL.revokeObjectURL(loaderThumbUrl); loaderThumbUrl = null; }
      box.classList.remove('is-done', 'is-leaving');
    }, 600);
  }

  /* `f` est l'avancement DANS l'étape (0 → 1), et non un pourcentage du rail :
     le pourcentage est DÉDUIT des bornes de l'étape. C'est ce qui garantit
     qu'un segment ne se remplit que pendant l'étape qu'il représente — les
     appelants n'ont plus aucun moyen de déborder sur le segment suivant. */
  function setProcessingUI(step, f, detail, indetermine) {
    var box = document.getElementById('banco-photo-loader');
    if (!box) return;
    if (step === null) { closePhotoLoader(); return; }
    /* jamais de marche arrière d'étape : le comptage des octets du modèle
       continue en tâche de fond et rappelait l'étape 2 alors que la gravure
       était déjà posée — la barre ne reculait pas, mais le libellé si */
    if (step < loaderStep) return;
    loaderStep = step;

    var bornes = LOADER_BORNES[step - 1] || LOADER_BORNES[3];
    var pct = bornes[0] + Math.max(0, Math.min(1, f)) * (bornes[1] - bornes[0]);
    box.setAttribute('data-step', String(step));
    /* jamais de retour en arrière : la reptation a pu dépasser l'annonce */
    loaderCible = Math.max(loaderCible, pct);
    loaderFini = step >= 4 && f >= 1;
    loaderPlafond = loaderFini ? 100 : Math.max(loaderCible, bornes[1] - 1);
    box.classList.toggle('is-done', loaderFini);

    var rail = document.getElementById('banco-loader-rail');
    if (rail) rail.classList.toggle('is-indeterminate', !!indetermine);
    box.classList.toggle('is-indeterminate', !!indetermine);

    remplacerTexte(document.getElementById('banco-loader-title'),
                   loaderFini ? LOADER_TITRE_FIN : LOADER_TITRE);
    remplacerTexte(document.getElementById('banco-loader-step-label'), LOADER_ETAPES[step] || '');
    remplacerTexte(document.getElementById('banco-loader-detail'), detail || LOADER_DETAIL[step] || '');
    relancerTween();
  }

  function loaderVisible() {
    var box = document.getElementById('banco-photo-loader');
    return !!(box && box.classList.contains('visible'));
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function setDropzoneBusy(on) {
    var dz = document.getElementById('banco-dropzone');
    if (dz) dz.classList.toggle('is-busy', !!on);
    var input = document.getElementById('banco-image-input');
    if (input) input.disabled = !!on;
  }

  // --- CONVERSION GRAVURE LASER (niveaux de gris + auto-niveaux + courbe S + netteté) ---

  function convertToGrayscale(img) {
    var maxSide = 1400;
    var imgW = img.naturalWidth || img.width || 1;
    var imgH = img.naturalHeight || img.height || 1;
    var ratio = Math.min(maxSide / imgW, maxSide / imgH, 1);
    var w = Math.max(1, Math.round(imgW * ratio));
    var h = Math.max(1, Math.round(imgH * ratio));

    var off = document.createElement('canvas');
    off.width = w; off.height = h;
    var octx = off.getContext('2d');
    octx.imageSmoothingEnabled = true;
    octx.imageSmoothingQuality = 'high';
    octx.drawImage(img, 0, 0, w, h);

    try {
      var imageData = octx.getImageData(0, 0, w, h);
      var d = imageData.data;
      var n = w * h;
      var grayArr = new Float32Array(n);
      var alphaArr = new Uint8Array(n);
      var hist = new Uint32Array(256);
      var ii, pi, g;

      // Passe 1 : luminance + histogramme
      for (ii = 0; ii < n; ii++) {
        pi = ii * 4;
        alphaArr[ii] = d[pi + 3];
        if (d[pi + 3] < 30) { grayArr[ii] = -1; continue; }
        g = 0.299 * d[pi] + 0.587 * d[pi + 1] + 0.114 * d[pi + 2];
        grayArr[ii] = g;
        hist[Math.round(g)]++;
      }

      // Auto-niveaux : écrêtage à 0,5 % de chaque côté
      var totalPx = 0, hidx;
      for (hidx = 0; hidx < 256; hidx++) totalPx += hist[hidx];
      var clipCnt = Math.round(totalPx * 0.005);
      var loIn = 0, hiIn = 255, acc = 0;
      for (hidx = 0; hidx < 256; hidx++) { acc += hist[hidx]; if (acc >= clipCnt) { loIn = hidx; break; } }
      acc = 0;
      for (hidx = 255; hidx >= 0; hidx--) { acc += hist[hidx]; if (acc >= clipCnt) { hiIn = hidx; break; } }
      var inRange = Math.max(hiIn - loIn, 1);

      // Courbe S (k=5) — précalculer les bornes une seule fois
      var SCURVE_K = 5;
      var scMin = 1 / (1 + Math.exp(SCURVE_K * 0.5));
      var scMax = 1 / (1 + Math.exp(-SCURVE_K * 0.5));
      var scRange = scMax - scMin;

      // Passe 2 : auto-niveaux + courbe S → sortie N&B
      var norm, sc, out;
      for (ii = 0; ii < n; ii++) {
        pi = ii * 4;
        if (alphaArr[ii] < 30) { d[pi]=0; d[pi+1]=0; d[pi+2]=0; d[pi+3]=0; continue; }
        norm = Math.max(0, Math.min(1, (grayArr[ii] - loIn) / inRange));
        sc = 1 / (1 + Math.exp(-SCURVE_K * (norm - 0.5)));
        norm = (sc - scMin) / scRange;
        out = Math.max(0, Math.min(255, Math.round(norm * 255)));
        d[pi] = out; d[pi+1] = out; d[pi+2] = out;
      }
      octx.putImageData(imageData, 0, 0);

      // Passe 3 : netteté (kernel de Laplacien : centre=5, voisins=-1)
      var imgData2 = octx.getImageData(0, 0, w, h);
      var src = imgData2.data;
      var dst = new Uint8ClampedArray(src.length);
      var x, y, ci, sv, at, ab, al, ar;
      for (y = 1; y < h - 1; y++) {
        for (x = 1; x < w - 1; x++) {
          ci = (y * w + x) * 4;
          if (src[ci + 3] < 30) { dst[ci]=0; dst[ci+1]=0; dst[ci+2]=0; dst[ci+3]=0; continue; }
          at = src[((y-1)*w+x)*4+3]; ab = src[((y+1)*w+x)*4+3];
          al = src[(y*w+x-1)*4+3];  ar = src[(y*w+x+1)*4+3];
          if (at < 30 || ab < 30 || al < 30 || ar < 30) {
            dst[ci]=src[ci]; dst[ci+1]=src[ci+1]; dst[ci+2]=src[ci+2]; dst[ci+3]=src[ci+3];
            continue;
          }
          sv = 5*src[ci] - src[((y-1)*w+x)*4] - src[((y+1)*w+x)*4] - src[(y*w+x-1)*4] - src[(y*w+x+1)*4];
          out = Math.max(0, Math.min(255, sv));
          dst[ci]=out; dst[ci+1]=out; dst[ci+2]=out; dst[ci+3]=src[ci+3];
        }
      }
      for (x = 0; x < w; x++) {
        ci = x*4; dst[ci]=src[ci]; dst[ci+1]=src[ci+1]; dst[ci+2]=src[ci+2]; dst[ci+3]=src[ci+3];
        ci = ((h-1)*w+x)*4; dst[ci]=src[ci]; dst[ci+1]=src[ci+1]; dst[ci+2]=src[ci+2]; dst[ci+3]=src[ci+3];
      }
      for (y = 1; y < h - 1; y++) {
        ci = y*w*4; dst[ci]=src[ci]; dst[ci+1]=src[ci+1]; dst[ci+2]=src[ci+2]; dst[ci+3]=src[ci+3];
        ci = (y*w+w-1)*4; dst[ci]=src[ci]; dst[ci+1]=src[ci+1]; dst[ci+2]=src[ci+2]; dst[ci+3]=src[ci+3];
      }
      imgData2.data.set(dst);
      octx.putImageData(imgData2, 0, 0);

    } catch (e) {}
    return off;
  }

  // --- MOTEUR GRAVURE (banco-engraving-engine.js) ---

  function hasEngine() { return typeof window.BancoEngravingEngine === 'function'; }

  function currentContrast() {
    var input = document.getElementById('banco-engrave-contrast');
    return input ? parseInt(input.value, 10) / 100 : 0.35;
  }

  function imageEls() {
    return state.elements.filter(function (e) { return e.type === 'image'; });
  }

  function updateEngraveControls() {
    var hasImage = imageEls().length > 0;
    var box = document.getElementById('banco-engrave-controls');
    if (box) box.style.display = hasImage ? '' : 'none';
    var bgField = document.getElementById('banco-bg-field');
    if (bgField) bgField.style.display = hasImage ? '' : 'none';
    if (!hasImage) {
      var warn = document.getElementById('banco-quality-warning');
      if (warn) warn.style.display = 'none';
    }
    majDropzone();
    syncBgUI();
  }

  /* Une fois la photo posée, la grande zone de dépôt n'a plus rien à demander :
     elle se replie en une ligne qui nomme le fichier reçu. La colonne de
     réglages y gagne la place qu'il faut pour voir le texte et le contraste
     sans faire défiler. */
  var dropzoneTextes = null;
  function majDropzone() {
    var dz = document.getElementById('banco-dropzone');
    if (!dz) return;
    var titre = dz.querySelector('.banco-dropzone-title');
    var sous = dz.querySelector('.banco-dropzone-sub');
    if (!titre || !sous) return;
    if (!dropzoneTextes) dropzoneTextes = { titre: titre.innerHTML, sous: sous.innerHTML };

    var els = imageEls();
    dz.classList.toggle('has-photo', els.length > 0);
    if (!els.length) {
      titre.innerHTML = dropzoneTextes.titre;
      sous.innerHTML = dropzoneTextes.sous;
      return;
    }
    var nom = (els[0]._file && els[0]._file.name) || 'Photo importée';
    if (nom.length > 30) nom = nom.slice(0, 27) + '…';
    titre.textContent = els.length > 1 ? els.length + ' photos importées' : nom;
    sous.innerHTML = 'Cliquez pour <span class="banco-dropzone-link">ajouter une autre photo</span>';
  }

  // --- ARRIÈRE-PLAN : RETIRÉ OU CONSERVÉ ---

  /* La case reflète l'INTENTION du client (bgWanted), pas l'état déjà calculé :
     le détourage arrive quelques secondes après l'aperçu, la case ne doit pas
     sauter de cochée à décochée entre-temps. Le badge, lui, dit ce qui est
     réellement gravé à l'instant. */
  function syncBgUI() {
    var els = imageEls();
    var cb = document.getElementById('banco-remove-bg');
    var hint = document.getElementById('banco-bg-hint');
    var badge = document.getElementById('banco-ai-badge');
    var wanted = els.length > 0 && els.every(function (el) { return el.bgWanted; });
    var removed = els.length > 0 && els.every(function (el) { return el.bgRemoved; });
    var busy = els.some(function (el) { return el._bgPending; });
    var failed = els.some(function (el) { return el.bgWanted && el._bgFailed; });

    if (cb) {
      cb.checked = wanted;
      cb.disabled = busy;
    }
    /* avant tout import le badge reste une promesse produit ; ensuite il dit
       l'état réel de la photo — et par quel chemin elle est passée */
    var trait = els.length > 0 && els.every(function (el) {
      return el._rapport && el._rapport.detourage === 'aplat';
    });
    if (badge) {
      badge.textContent = !els.length ? 'Fond supprimé par IA'
        : removed ? (trait ? 'Tracé du logo isolé' : 'Fond supprimé par IA')
        : 'Photo entière gravée';
    }
    /* motif précis du repli quand il y en a un : « aucun sujet net » n'est pas
       la même chose qu'un détourage en panne, et le client mérite de le savoir */
    var motif = null;
    els.forEach(function (el) { if (el._bgMotif) motif = el._bgMotif; });
    if (hint) {
      hint.textContent = busy
        ? (trait
            ? 'Découpe exacte du tracé, sans passer par l\'IA.'
            : bgModelReady
              ? 'Détourage en cours… votre photo s\'affiche sur le produit dès qu\'elle est prête.'
              : 'Première utilisation : l\'IA se télécharge une seule fois (56 Mo), ensuite le détourage est quasi immédiat.')
        : failed
          ? (motif || 'Le détourage n\'a pas abouti sur cette photo : elle est gravée avec son décor.') +
            ' Décochez puis recochez pour réessayer.'
          : removed
            ? (trait
                ? 'Seul le tracé du logo est gravé, le fond reste du bois nu.'
                : 'Seul le sujet est gravé. Décochez pour graver la photo entière, avec son décor.')
            : 'Photo gravée avec son décor. Cochez pour ne garder que le sujet.';
    }
  }

  /* Lance le détourage d'une photo en tâche de fond. L'aperçu reste utilisable
     pendant le calcul ; le résultat n'est appliqué que si le client veut
     toujours du détourage à ce moment-là. */
  function startBgRemoval(el) {
    if (el._bgPending || el._imgCutout || !el._file) return;
    /* même verrou que l'import : une seule inférence à la fois, sinon deux
       calculs en parallèle saturent la mémoire des mobiles */
    state.photoLoading = true;
    setDropzoneBusy(true);
    openPhotoLoader(el._file);
    setProcessingUI(2, 0);
    reportBgProgress();
    el._bgPending = preparerSujet(el._file, el._imgOriginal, el._rapport).then(function (res) {
      el._bgPending = null;
      var img = res && res.image;
      /* _bgFailed évite de relancer en boucle une photo que l'IA refuse ;
         seul un décochage/recochage explicite retente */
      if (img) el._imgCutout = img;
      else { el._bgFailed = true; el._bgMotif = (res && res.note) || null; }
      var rate = img ? null
        : ((res && res.note) || 'Détourage impossible — la photo est gravée avec son décor');
      setProcessingUI(3, 0.2, rate);
      return delay(120)
        .then(function () {
          setProcessingUI(3, 1, rate);
          return delay(150);
        })
        .then(function () {
          setProcessingUI(4, 0.35, rate);
          return delay(180);
        })
        .then(function () {
          setProcessingUI(4, 1, rate);
          return delay(img ? 480 : 1500);
        })
        .then(function () {
          endPhotoLoading();
          var vivant = state.elements.indexOf(el) !== -1;
          if (img && vivant && el.bgWanted) {
            applyBackgroundState(true);
            startScanReveal(el); /* la gravure se refait sous les yeux du client */
          } else {
            syncBgUI();
          }
          var suivante = imageEls().filter(function (o) {
            return o.bgWanted && !o._imgCutout && !o._bgPending && !o._bgFailed && o._file;
          })[0];
          if (suivante) startBgRemoval(suivante);
        });
    }).catch(function (err) {
      /* Sans ce filet, un échec inattendu (mémoire saturée, canvas trop grand)
         laissait le voile affiché, `photoLoading` à true et `_bgPending` armé :
         la zone de dépôt restait grisée et le client ne pouvait plus rien
         ajouter jusqu'au rechargement de la page. */
      console.error('[BANCO] Détourage en tâche de fond interrompu :', err);
      el._bgPending = null;
      el._bgFailed = true;
      endPhotoLoading();
      syncBgUI();
    });
    syncBgUI();
  }

  /* Bascule appliquée à toutes les photos de l'aperçu. Le détourage n'est
     recalculé que s'il n'a jamais abouti pour cette photo. */
  function setBackgroundRemoved(on) {
    var els = imageEls();
    if (!els.length) { syncBgUI(); return; }
    /* recocher = nouvelle tentative autorisée sur une photo que l'IA a refusée */
    els.forEach(function (el) { el.bgWanted = on; if (on) el._bgFailed = false; });

    applyBackgroundState(on);
    if (on) {
      /* une seule inférence à la fois : deux en parallèle saturent la mémoire
         des mobiles — startBgRemoval enchaîne les photos suivantes */
      var enCours = els.some(function (el) { return el._bgPending; });
      var suivante = els.filter(function (el) { return !el._imgCutout && el._file; })[0];
      if (!enCours && suivante) startBgRemoval(suivante);
    }
  }

  function applyBackgroundState(on) {
    imageEls().forEach(function (el) {
      el.bgWanted = on;
      var target = on ? (el._imgCutout || el._imgOriginal) : el._imgOriginal;
      if (!target) return;
      el.bgRemoved = !!(on && el._imgCutout);
      setElementSource(el, target);
    });
    syncBgUI();
    renderCanvas();
  }

  /* Change la photo source d'un élément sans perdre sa position ni sa taille,
     et relance la conversion gravure sur la nouvelle source. */
  function setElementSource(el, img) {
    if (el._imgEl === img) return;
    el._imgEl = img;
    var newW = img.naturalWidth || img.width;
    var newH = img.naturalHeight || img.height;
    /* le détourage conserve normalement les dimensions ; par sécurité, si le
       ratio diffère on garde la largeur et le centre du cadre */
    if (newW && newH && el.w && el.h && Math.abs(newH / newW - el.h / el.w) > 0.01) {
      var cy = el.y + el.h / 2;
      el.h = Math.max(1, Math.round(el.w * (newH / newW)));
      el.y = Math.round(cy - el.h / 2);
    }
    if (el._engine) {
      if (el._rapport && el._engine.appliquerAnalyse) el._engine.appliquerAnalyse(el._rapport);
      el._engine.setSource(img);
      el._engine.setParams({ contrast: currentContrast() });
      el._engraving = el._engine.renderEngraving();
      showQualityWarning(el._engine.analyzeQuality(100));
    } else {
      el._bwCanvas = convertToGrayscale(img);
    }
  }

  var engraveRebuildTimer = null;
  function rebuildEngravings(interactive, contrast) {
    var els = imageEls();
    if (!els.length) return;
    els.forEach(function (el) {
      if (!el._engine) return;
      el._engine.setInteractive(interactive);
      el._engine.setParams({ contrast: contrast });
      el._engraving = el._engine.renderEngraving();
    });
    renderCanvas();
    /* pendant le drag : rendu rapide (Bayer) ; à l'arrêt : rendu qualité (Atkinson) */
    clearTimeout(engraveRebuildTimer);
    if (interactive) {
      engraveRebuildTimer = setTimeout(function () {
        rebuildEngravings(false, contrast);
      }, 350);
    }
  }

  function showQualityWarning(quality) {
    var warn = document.getElementById('banco-quality-warning');
    if (!warn) return;
    if (quality && quality.messages && quality.messages.length) {
      warn.textContent = '⚠️ ' + quality.messages.join(' ');
      warn.style.display = '';
    } else {
      warn.style.display = 'none';
    }
  }

  /* Animation "scan laser" : la photo couleur s'estompe pendant qu'une ligne
     incandescente balaye et révèle la gravure, comme la vraie machine. */
  function startScanReveal(el) {
    if (mouvementReduit()) return;
    if (!el._engraving) return;
    el._reveal = { t: 0, start: null };
    function step(now) {
      if (!el._reveal) return;
      if (el._reveal.start === null) el._reveal.start = now;
      var brut = Math.min(1, (now - el._reveal.start) / 1500);
      /* la tête de gravure ne démarre pas au quart de tour et ne s'arrête pas
         net : accélération puis freinage (easeInOutCubic). En linéaire, le
         départ et l'arrivée se voyaient comme deux à-coups. */
      el._reveal.t = brut < 0.5
        ? 4 * brut * brut * brut
        : 1 - Math.pow(-2 * brut + 2, 3) / 2;
      renderCanvas();
      if (el._reveal.t < 1 && state.elements.indexOf(el) !== -1) {
        requestAnimationFrame(step);
      } else {
        el._reveal = null;
        renderCanvas();
      }
    }
    requestAnimationFrame(step);
  }

  // --- ADD PHOTO ---

  /* La photo n'apparaît sur le produit qu'une fois PRÊTE : détourée puis
     convertie en gravure noir & blanc. Pendant le calcul (quelques secondes,
     bien plus à la première visite le temps de télécharger le modèle), le voile
     occupe l'aperçu et détaille chaque étape — auparavant la photo brute
     s'affichait d'abord en couleur avec son décor, ce qui laissait croire à un
     raté. Si l'IA échoue, la photo est tout de même posée, avec son décor. */
  function addImageAsync(file) {
    var sizePercent = 50; /* taille initiale — ajustable via la poignée sur l'aperçu */
    var fileInput = document.getElementById('banco-image-input');
    if (state.photoLoading) return; /* une seule inférence à la fois */
    var produit = state.selectedProduct;

    state.photoLoading = true;
    setDropzoneBusy(true);
    openPhotoLoader(file);
    setProcessingUI(1, 0.12);

    var original = null, rapport = null;
    blobToImage(file)
      .then(function (img) {
        original = img;
        /* le fichier est décodé : l'étape 1 est aux deux tiers. L'analyse qui
           suit est synchrone et fige le fil — elle doit être peinte avant,
           sinon le segment 1 saute de 12 % à plein sans jamais se remplir */
        setProcessingUI(1, 0.68, 'Analyse du contenu de l\'image…');
        /* l'analyse qui suit est synchrone : on la laisse peindre avant */
        return delay(140).then(figerProprement);
      })
      .then(function () {
        rapport = analyserImage(original);
        setProcessingUI(2, 0);
        return preparerSujet(file, original, rapport);
      })
      .then(function (res) {
        /* le client a changé de produit entre-temps : on n'ajoute rien */
        if (state.selectedProduct !== produit) return null;
        var cutout = res && res.image;
        /* détourage impossible : on le dit jusqu'au bout plutôt que d'annoncer
           une gravure « prête » alors que le décor est resté */
        var rate = cutout ? null
          : ((res && res.note) || 'Détourage impossible — la photo est gravée avec son décor');
        setProcessingUI(3, 0.15, rate);
        /* respiration : la conversion gravure fige le fil principal une
           fraction de seconde, l'étape 3 doit être peinte avant */
        return delay(120).then(figerProprement).then(function () {
          var el = buildImageElement(
            { original: original, cutout: cutout, rapport: rapport }, sizePercent, file);
          /* IA indisponible ou masque refusé : on ne relance pas en boucle */
          if (el && !cutout) {
            el._bgFailed = true;
            el._bgMotif = (res && res.note) || null;
          }
          /* la conversion est faite : le segment 3 se termine, puis le 4 court
             pendant la mise en place. Les deux derniers segments — soit 22 % du
             rail — se remplissaient auparavant en 120 ms, donc jamais vus. */
          setProcessingUI(3, 1, rate);
          syncBgUI();
          return delay(150)
            .then(function () {
              setProcessingUI(4, 0.35, rate);
              return delay(180);
            })
            .then(function () {
              setProcessingUI(4, 1, rate);
              return delay(cutout ? 480 : 1500);
            })
            .then(function () { return el; });
        });
      })
      .then(function (el) {
        endPhotoLoading();
        try { fileInput.value = ''; } catch (e) {}
        /* la gravure se fait sous les yeux du client pendant que le voile
           s'efface */
        if (el) startScanReveal(el);
      })
      .catch(function (err) {
        console.error('[BANCO] Image error:', err);
        endPhotoLoading();
        try { fileInput.value = ''; } catch (e) {}
        alert('Impossible de charger cette image. Essayez un autre format.');
      });
  }

  function endPhotoLoading() {
    state.photoLoading = false;
    setDropzoneBusy(false);
    closePhotoLoader();
  }

  /* --- PRÉPARATION DU SUJET ------------------------------------------------
     Aiguillage central : selon ce que l'analyse a reconnu, on isole le sujet
     de trois façons très différentes.

       logo / dessin  → découpe exacte à la couleur de fond, sans IA. Instantané
                        (60 ms au lieu de 8 s) et surtout FIDÈLE : l'IA rognait
                        les lettres qui touchent le bord et laissait un voile
                        gris dans les contre-formes.
       photo          → IA, puis nettoyage du masque (halo, îlots de décor).
       masque raté    → on refuse le détourage et on grave la photo entière :
                        un paysage sans sujet net rendait la planche VIDE.

     Résout avec { image, note, refus }. */
  function analyserImage(img) {
    if (!window.BancoImageAnalysis) return null;
    try { return window.BancoImageAnalysis.analyser(img); }
    catch (e) { console.warn('[BANCO] Analyse indisponible :', e); return null; }
  }

  function preparerSujet(file, original, rapport) {
    var A = window.BancoImageAnalysis;

    if (A && rapport && rapport.detourage === 'aplat') {
      setProcessingUI(2, 0.45, 'Logo reconnu — découpe exacte du tracé');
      try {
        var encre = A.extraireEncre(original, rapport);
        /* découpe instantanée : sans ceci le segment 2 restait à mi-course
           jusqu'à l'étape 3, qui l'achevait d'un coup */
        setProcessingUI(2, 1, 'Logo reconnu — découpe exacte du tracé');
        return Promise.resolve({ image: encre, note: null, refus: false });
      } catch (e) {
        console.warn('[BANCO] Extraction du tracé impossible :', e);
      }
    }

    return detourerEnDeuxPasses(file, original).then(function (r) {
      /* le nettoyage du masque qui suit (portillon + filtre guidé) est
         synchrone et fige le fil à son tour : on peint l'étape avant */
      return figerProprement().then(function () { return r; });
    }).then(function (r) {
      var brut = r.masque;
      if (!brut) return { image: null, note: null, refus: false };
      if (!A) return { image: brut, note: null, refus: false };
      /* dessin au trait passé quand même par l'IA (logo photographié, capture
         d'écran sur un dégradé) : son masque est fin et morcelé par nature */
      var trait = !!(rapport && rapport.nature === 'trait');
      try {
        var note = A.noterMasque(brut);
        if (!note.exploitable && !trait) {
          /* masque « poussière » : mieux vaut la photo entière qu'une planche
             quasi nue que le client prendrait pour un bug */
          return {
            image: null, refus: true,
            note: 'Aucun sujet net à détourer sur cette photo : elle est gravée telle quelle.'
          };
        }
        /* le guide doit avoir EXACTEMENT le cadrage du masque : après une
           deuxième passe c'est la découpe, pas la photo entière */
        return {
          image: A.nettoyerMasque(brut, { guide: r.guide || original, trait: trait }),
          note: null, refus: false
        };
      } catch (e) {
        console.warn('[BANCO] Nettoyage du masque impossible :', e);
        return { image: brut, note: null, refus: false };
      }
    });
  }

  /* --- DEUXIÈME PASSE SUR LE SUJET RECADRÉ ---------------------------------
     Le modèle ramène toujours l'image à un carré de 1024 px avant de
     travailler. Quand le sujet n'occupe qu'un quart de la photo — une personne
     photographiée de loin, un couple au bout d'une allée — il ne lui en reste
     que cinq cents : le contour ne PEUT pas être fin, aucun post-traitement ne
     rattrapera ce qui n'a jamais été calculé.

     On relance donc le modèle sur le sujet recadré, qui occupe cette fois tout
     le carré. Mesuré sur le corpus d'essai : sur les photos à petit sujet, la
     silhouette passe d'une tache à un contour détaillé (manteau, chevelure,
     plis d'un kimono).

     Ça coûte une inférence de plus (~8 s) : on ne la paie donc QUE si elle
     rapporte, c'est-à-dire quand le sujet est vraiment petit dans le cadre. */
  var SEUIL_2E_PASSE = 0.40; /* part du cadre occupée par le sujet */

  function cadreSujet(img) {
    var c = document.createElement('canvas');
    var W = img.naturalWidth || img.width, H = img.naturalHeight || img.height;
    var s = Math.min(1, 400 / Math.max(W, H));
    c.width = Math.max(1, Math.round(W * s));
    c.height = Math.max(1, Math.round(H * s));
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, c.width, c.height);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    var x0 = c.width, y0 = c.height, x1 = -1, y1 = -1, i, j;
    for (j = 0; j < c.height; j++) {
      for (i = 0; i < c.width; i++) {
        if (d[(j * c.width + i) * 4 + 3] < 60) continue;
        if (i < x0) x0 = i;
        if (i > x1) x1 = i;
        if (j < y0) y0 = j;
        if (j > y1) y1 = j;
      }
    }
    if (x1 < 0) return null;
    return {
      x: x0 / c.width, y: y0 / c.height,
      w: (x1 - x0 + 1) / c.width, h: (y1 - y0 + 1) / c.height
    };
  }

  function recadrerAvecMarge(img, box, marge) {
    var W = img.naturalWidth || img.width, H = img.naturalHeight || img.height;
    var mx = box.w * marge * W, my = box.h * marge * H;
    var x0 = Math.max(0, box.x * W - mx), y0 = Math.max(0, box.y * H - my);
    var x1 = Math.min(W, (box.x + box.w) * W + mx);
    var y1 = Math.min(H, (box.y + box.h) * H + my);
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(x1 - x0));
    c.height = Math.max(1, Math.round(y1 - y0));
    c.getContext('2d').drawImage(img, x0, y0, c.width, c.height, 0, 0, c.width, c.height);
    return c;
  }

  function canvasEnBlob(c) {
    return new Promise(function (ok) { c.toBlob(ok, 'image/png'); });
  }

  /* Résout avec { masque, guide } : le guide est la photo au cadrage du masque. */
  function detourerEnDeuxPasses(file, original) {
    return removeBackgroundImage(file, null, BG_PASSE1).then(function (m1) {
      /* chaque sortie de l'étape 2 la clôt explicitement : le segment 2 doit
         être plein AVANT que le libellé passe à l'étape 3 */
      if (!m1 || !original) { setProcessingUI(2, 1); return { masque: m1, guide: null }; }
      var box;
      try { box = cadreSujet(m1); } catch (e) { box = null; }
      if (!box || box.w * box.h >= SEUIL_2E_PASSE) {
        setProcessingUI(2, 1);
        return { masque: m1, guide: null };
      }

      var coupe;
      /* un recadrage impossible (canvas hors limites sur mobile) ne doit pas
         faire tomber toute la chaîne : la 1re passe est déjà exploitable */
      try { coupe = recadrerAvecMarge(original, box, 0.10); }
      catch (e) { setProcessingUI(2, 1); return { masque: m1, guide: null }; }
      return canvasEnBlob(coupe)
        .then(function (blob) {
          return removeBackgroundImage(blob, 'Sujet éloigné — deuxième passe pour l\u2019affiner', BG_PASSE2);
        })
        .then(function (m2) {
          setProcessingUI(2, 1);
          if (!m2) return { masque: m1, guide: null };
          /* La 2e passe part d'une image déjà cadrée sur le sujet : il doit y
             occuper une large part. S'il n'en reste presque rien, c'est que le
             modèle s'est perdu sur ce cadrage — on revient sans bruit à la
             première passe plutôt que de livrer un masque pire. */
          var A = window.BancoImageAnalysis;
          if (A) {
            try {
              if (A.noterMasque(m2).couverture < 0.15) return { masque: m1, guide: null };
            } catch (e) {}
          }
          return { masque: m2, guide: coupe };
        })
        .catch(function () { setProcessingUI(2, 1); return { masque: m1, guide: null }; });
    });
  }

  /* Détourage IA d'un fichier : résout avec l'<img> détourée, ou null si l'IA
     n'a pas pu s'exécuter (module indisponible, mémoire, format exotique…) —
     dans ce cas la photo est simplement gravée avec son arrière-plan. */
  function removeBackgroundImage(file, libelle, plage) {
    /* `plage` = [début, fin] en fraction de l'étape 2, pas en pourcentage du
       rail : une passe ne peut plus mordre sur les segments suivants. */
    var pl = plage || BG_PASSE1;
    /* On ATTEND le préchargement lancé à l'ouverture du configurateur au lieu de
       lancer un second téléchargement en parallèle : les deux se disputaient la
       même bande passante et le modèle descendait deux fois. */
    var pret = preloadBgRemoval() || Promise.resolve();
    return pret
      .then(function () { return loadBgRemoval(); })
      .then(function (mod) {
        var texte = libelle || 'Calcul de la découpe autour du sujet…';
        setProcessingUI(2, pl[0], texte, true);
        /* Le calcul qui suit FIGE le fil principal. La barre et le libellé
           doivent donc être à l'écran AVANT de le lancer, sinon le client passe
           toute l'attente devant l'état précédent — barre coincée dans le
           premier segment et lignes de texte vides (capture du 30/08/2026). */
        return figerProprement().then(function () {
          return mod.removeBackground(file, {
            model: BG_MODEL,
            progress: function (key, current, total) {
              /* si la librairie sait chiffrer l'inférence on repasse en barre
                 chiffrée ; sinon la barre balaie (durée non prévisible) */
              if (total > 0 && /^compute/.test(key)) {
                setProcessingUI(2, pl[0] + (pl[1] - pl[0]) * (current / total), texte);
              }
            }
          });
        });
      })
      .then(function (blob) {
        bgModelReady = true;
        setProcessingUI(2, pl[1]);
        return blobToImage(blob);
      })
      .catch(function (err) {
        console.warn('[BANCO] Détourage indisponible, photo conservée avec son fond :', err);
        setProcessingUI(2, pl[1], 'Détourage impossible sur cette photo — décor conservé');
        return null;
      });
  }

  function blobToImage(source) {
    return new Promise(function (resolve, reject) {
      var isBlob = source instanceof Blob;
      var url = isBlob ? URL.createObjectURL(source) : null;
      var img = new Image();
      img.onload = function () { if (url) URL.revokeObjectURL(url); resolve(img); };
      img.onerror = function () {
        if (url) URL.revokeObjectURL(url);
        if (!isBlob) { reject(new Error('load failed')); return; }
        var reader = new FileReader();
        reader.onload = function (e) {
          var img2 = new Image();
          img2.onload = function () { resolve(img2); };
          img2.onerror = reject;
          img2.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(source);
      };
      img.src = url || (typeof source === 'string' ? source : '');
    });
  }

  function buildImageElement(sources, sizePercent, origFile) {
    var original = sources.original;
    var cutout = sources.cutout || null;
    var rapport = sources.rapport || null;
    /* le détourage réussi est la version affichée par défaut */
    var img = cutout || original;
    if (!img || !(img.naturalWidth || img.width)) return;
    var imgW = img.naturalWidth || img.width;
    var imgH = img.naturalHeight || img.height;
    /* Cadrage dans la zone réellement gravable du produit, format respecté.
       Auparavant la photo entrait dans un carré de 50 % du canevas : une photo
       panoramique arrivait minuscule et une photo portrait flottait au milieu
       d'un grand vide, alors que le client attend une gravure qui occupe
       l'article comme sur les photos de l'atelier. */
    var zone = zoneGravure();
    var scale = Math.min(zone.w / imgW, zone.h / imgH);
    var w = Math.max(1, Math.round(imgW * scale));
    var h = Math.max(1, Math.round(imgH * scale));

    var el = {
      id: nextId++, type: 'image',
      _imgEl: img,               /* source affichée : détourée ou avec fond */
      _imgOriginal: original,    /* photo telle qu'importée (fond compris) */
      _imgCutout: cutout,        /* sujet isolé — null si indisponible */
      _rapport: rapport,         /* analyse : nature, réglages, détourage */
      _bgPending: null,          /* détourage en cours (promesse) */
      bgWanted: true,            /* case « Retirer l'arrière-plan » cochée */
      bgRemoved: !!cutout,       /* détourage réellement appliqué à l'aperçu */
      sizePercent: Math.round(Math.max(w, h) / Math.min(CANVAS_W, CANVAS_H) * 100),
      rotation: 0,
      showOriginal: false,
      _file: origFile || null, /* fichier ORIGINAL du client, joint à la commande */
      x: Math.round(zone.x + (zone.w - w) / 2),
      y: Math.round(zone.y + (zone.h - h) / 2),
      w: w, h: h, _bounds: null,
    };

    if (hasEngine()) {
      /* rendu gravure réaliste : tramage Atkinson + brûlure fondue au bois */
      el._engine = new window.BancoEngravingEngine({
        previewMaxSize: 1200,
        contrast: currentContrast(),
        dither: 'atkinson'
      });
      /* réglages déduits de l'analyse : un logo, un portrait et un animal
         n'appellent ni la même courbe ni le même contraste local */
      if (rapport && el._engine.appliquerAnalyse) el._engine.appliquerAnalyse(rapport);
      el._engine.setSource(img);
      el._engraving = el._engine.renderEngraving();
      showQualityWarning(el._engine.analyzeQuality(100));
    } else {
      el._bwCanvas = convertToGrayscale(img); /* repli : ancien rendu N&B */
    }

    state.elements.push(el);
    state.selectedId = el.id;
    var showOriginalCb = document.getElementById('banco-show-original');
    if (showOriginalCb) showOriginalCb.checked = false;
    updateEngraveControls();
    renderCanvas();
    renderElementsList();
    /* le balayage laser est déclenché par l'appelant, une fois le voile de
       préparation effacé — sinon l'animation se joue derrière le voile */
    return el;
  }

  function deleteElement(id) {
    if (id === state.liveTextId) {
      state.liveTextId = null;
      var textarea = document.getElementById('banco-text-input');
      if (textarea) textarea.value = '';
    }
    state.elements = state.elements.filter(function (e) { return e.id !== id; });
    if (state.selectedId === id) state.selectedId = null;
    updateEngraveControls();
    renderCanvas();
    renderElementsList();
  }

  function renderElementsList() {
    if (!elementsListEl) return;
    if (!state.elements.length) {
      elementsListEl.innerHTML = '<p class="banco-elements-empty">Aucun élément ajouté</p>';
      return;
    }
    elementsListEl.innerHTML = '';
    state.elements.forEach(function (el) {
      var item = document.createElement('div');
      item.className = 'banco-element-item' + (state.selectedId === el.id ? ' selected' : '');
      var label = el.type === 'text'
        ? 'Texte — ' + el.text.substring(0, 22) + (el.text.length > 22 ? '…' : '')
        : 'Photo importée';
      item.innerHTML =
        '<span class="banco-element-label">' + escapeHtml(label) + '</span>' +
        '<button class="banco-element-del" title="Supprimer">×</button>';
      item.addEventListener('click', function (e) {
        if (e.target.classList.contains('banco-element-del')) {
          deleteElement(el.id);
        } else {
          state.selectedId = el.id;
          if (el.type === 'text') {
            state.liveTextId = el.id;
            var textarea = document.getElementById('banco-text-input');
            if (textarea) textarea.value = el.text;
            modal.querySelectorAll('.banco-tab').forEach(function (t) { t.classList.remove('active'); });
            modal.querySelectorAll('.banco-tab-content').forEach(function (t) { t.classList.remove('active'); });
            var textTab = modal.querySelector('.banco-tab[data-tab="text"]');
            if (textTab) textTab.classList.add('active');
            var textContent = document.getElementById('banco-tab-text');
            if (textContent) textContent.classList.add('active');
          }
          renderCanvas();
          renderElementsList();
        }
      });
      elementsListEl.appendChild(item);
    });
  }

  // --- CANVAS MOUSE / TOUCH ---

  function canvasPos(e) {
    var rect = canvas.getBoundingClientRect();
    return { x: (e.clientX - rect.left) * (CANVAS_W / rect.width), y: (e.clientY - rect.top) * (CANVAS_H / rect.height) };
  }

  function touchToMouse(e) {
    var t = e.touches[0] || e.changedTouches[0];
    return { clientX: t.clientX, clientY: t.clientY, preventDefault: function () {} };
  }

  function hitTest(x, y) {
    for (var i = state.elements.length - 1; i >= 0; i--) {
      var el = state.elements[i];
      if (!el._bounds) continue;
      var b = el._bounds;
      if (x >= b.x && x <= b.x + b.w && y >= b.y && y <= b.y + b.h) return el;
    }
    return null;
  }

  function onMouseDown(e) {
    if (e.preventDefault) e.preventDefault();
    var pos = canvasPos(e);
    if (state.selectedId !== null) {
      var sel = state.elements.find(function (el) { return el.id === state.selectedId; });
      var hk = handleAt(sel, pos.x, pos.y);
      if (hk === 'del') { deleteElement(state.selectedId); return; }
      if (hk === 'resize' || hk === 'rotate') {
        var hcx = sel.x + sel.w / 2, hcy = sel.y + sel.h / 2;
        state.drag = {
          element: sel,
          mode: hk,
          cx: hcx, cy: hcy,
          startW: sel.w, startH: sel.h,
          startDist: Math.max(12, Math.hypot(pos.x - hcx, pos.y - hcy)),
          startRot: sel.rotation || 0,
          startAngle: Math.atan2(pos.y - hcy, pos.x - hcx)
        };
        canvas.style.cursor = hk === 'resize' ? 'nwse-resize' : 'grabbing';
        return;
      }
    }
    var hit = hitTest(pos.x, pos.y);
    if (hit) {
      state.selectedId = hit.id;
      state.drag = { element: hit, mode: 'move', ox: pos.x - hit.x, oy: pos.y - hit.y };
      canvas.style.cursor = 'grabbing';
    } else { state.selectedId = null; state.drag = null; }
    renderCanvas(); renderElementsList();
  }

  function onMouseMove(e) {
    var pos = canvasPos(e);
    if (state.drag) {
      var d = state.drag, el = d.element;
      if (d.mode === 'move') {
        el.x = pos.x - d.ox;
        el.y = pos.y - d.oy;
        /* placé à la main : on cesse de le recentrer tout seul à la frappe */
        el._deplaceALaMain = true;
      } else if (d.mode === 'resize') {
        /* homothétie depuis le centre, ratio conservé */
        var f = Math.hypot(pos.x - d.cx, pos.y - d.cy) / d.startDist;
        var nw = Math.min(CANVAS_W * 2, Math.max(24, d.startW * f));
        f = nw / d.startW;
        el.w = Math.round(d.startW * f);
        el.h = Math.round(d.startH * f);
        el.x = Math.round(d.cx - el.w / 2);
        el.y = Math.round(d.cy - el.h / 2);
        el.sizePercent = Math.round(Math.max(el.w, el.h) / Math.min(CANVAS_W, CANVAS_H) * 100);
      } else if (d.mode === 'rotate') {
        var ang = Math.atan2(pos.y - d.cy, pos.x - d.cx);
        var deg = d.startRot + (ang - d.startAngle) * 180 / Math.PI;
        deg = ((deg + 180) % 360 + 360) % 360 - 180;
        /* aimantation douce sur les angles remarquables (tous les 15°) */
        var snap = Math.round(deg / 15) * 15;
        if (Math.abs(deg - snap) < 3) deg = snap;
        el.rotation = Math.round(deg);
      }
      renderCanvas();
      return;
    }
    var overSel = state.elements.find(function (s) { return s.id === state.selectedId; });
    var hk = handleAt(overSel, pos.x, pos.y);
    canvas.style.cursor = hk === 'resize' ? 'nwse-resize'
      : hk === 'rotate' ? 'grab'
      : hk === 'del' ? 'pointer'
      : (hitTest(pos.x, pos.y) ? 'grab' : 'default');
  }

  function onMouseUp() { state.drag = null; canvas.style.cursor = 'default'; }

  // --- ADD TO CART ---

  /* Poids maximal envoyé tel quel. Au-delà, la photo est ré-encodée : une photo
     de smartphone pèse couramment 4 à 12 Mo et partait jusqu'ici brute dans la
     requête d'ajout au panier. Sur une connexion mobile ordinaire cela demande
     plusieurs minutes pendant lesquelles le client ne voit qu'« Ajout en
     cours… » ; la moindre coupure, un changement d'application ou la mise en
     veille faisait échouer la requête — et l'ajout au panier avec elle. */
  var UPLOAD_MAX_BYTES = 1.5e6;
  /* 2400 px sur le grand côté : sur une planche de 30 cm cela reste au-dessus
     de ce que la graveuse restitue. Rien de perdu sur la gravure, dix fois
     moins d'octets à téléverser. */
  var UPLOAD_MAX_SIDE = 2400;

  /* Prépare la photo à joindre à la commande : le fichier d'origine s'il est
     déjà raisonnable (aucune perte), sinon une version redimensionnée en JPEG.
     Au moindre pépin on retombe sur le fichier d'origine. */
  function prepareUploadFile(file) {
    if (!file) return Promise.resolve(null);
    if (file.size <= UPLOAD_MAX_BYTES) return Promise.resolve(file);
    return blobToImage(file)
      .then(function (img) {
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        if (!w || !h) return file;
        var sc = Math.min(1, UPLOAD_MAX_SIDE / Math.max(w, h));
        var ow = Math.max(1, Math.round(w * sc));
        var oh = Math.max(1, Math.round(h * sc));
        var off = document.createElement('canvas');
        off.width = ow; off.height = oh;
        var c = off.getContext('2d');
        c.imageSmoothingEnabled = true;
        c.imageSmoothingQuality = 'high';
        c.drawImage(img, 0, 0, ow, oh);
        return new Promise(function (resolve) {
          if (!off.toBlob) { resolve(file); return; }
          off.toBlob(function (blob) {
            /* ré-encodage sans gain : on garde l'original */
            resolve(blob && blob.size < file.size ? blob : file);
          }, 'image/jpeg', 0.92);
        });
      })
      .catch(function () { return file; });
  }

  /* --- APERÇU JOINT À LA COMMANDE ---------------------------------------
     Photocopie de ce que le client a sous les yeux à la seconde où il ajoute
     au panier : l'article, la gravure, le texte, chacun à sa place exacte.
     La photo d'origine seule ne dit pas OÙ graver — cet aperçu, si.
     Rendu hors écran, à l'écart de l'aperçu affiché : ni poignées de
     sélection, ni fondu d'arrivée, ni scan laser en cours, ni bascule
     « voir la photo originale ». Le client, lui, ne voit rien bouger. */
  var APERCU_ECHELLE = 2; /* plancher de finesse : 1120 × 840 */

  function renderApercuBlob() {
    if (!ctx || !canvas) return Promise.resolve(null);
    var echelle = Math.max(APERCU_ECHELLE, PX);
    var off = document.createElement('canvas');
    off.width = Math.round(CANVAS_W * echelle);
    off.height = Math.round(CANVAS_H * echelle);
    var offCtx = off.getContext('2d');
    if (!offCtx) return Promise.resolve(null);
    /* même repère 560×420 que l'aperçu : rien à recalculer pour dessiner */
    offCtx.setTransform(echelle, 0, 0, echelle, 0, 0);
    offCtx.imageSmoothingEnabled = true;
    offCtx.imageSmoothingQuality = 'high';
    /* le JPEG ne connaît pas la transparence : sans ce fond, le moindre coin
       non couvert par l'article virerait au noir */
    offCtx.fillStyle = '#ffffff';
    offCtx.fillRect(0, 0, CANVAS_W, CANVAS_H);

    var ctxEcran = ctx;
    var selection = state.selectedId;
    var fondu = state.productFade;
    var sauve = state.elements.map(function (el) {
      return { el: el, reveal: el._reveal, original: el.showOriginal };
    });
    /* tout ce bloc est synchrone : le navigateur ne repeint pas au milieu,
       et aucune animation ne peut s'intercaler */
    try {
      ctx = offCtx;
      state.selectedId = null;
      state.productFade = 1;
      sauve.forEach(function (s) { s.el._reveal = null; s.el.showOriginal = false; });
      renderCanvas();
    } catch (e) {
      return Promise.resolve(null);
    } finally {
      ctx = ctxEcran;
      state.selectedId = selection;
      state.productFade = fondu;
      sauve.forEach(function (s) { s.el._reveal = s.reveal; s.el.showOriginal = s.original; });
      renderCanvas();
    }

    return new Promise(function (resolve) {
      try {
        if (!off.toBlob) { resolve(null); return; }
        off.toBlob(function (b) { resolve(b || null); }, 'image/jpeg', 0.92);
      } catch (e) {
        /* canvas « teinté » : la photo de l'article a été servie sans en-tête
           CORS (repli de chargement), les pixels deviennent illisibles. On
           part sans l'aperçu plutôt que de faire échouer l'ajout au panier. */
        resolve(null);
      }
    });
  }

  /* Message lisible par le client — l'ancien « Une erreur est survenue »
     ne disait ni quoi faire, ni ce qui s'était passé. */
  function cartErrorMessage(status, body) {
    if (!status) {
      return 'La connexion a été interrompue pendant l\'envoi de votre photo.\n\n'
        + 'Vérifiez votre connexion internet, puis réessayez.';
    }
    if (status === 429) {
      return 'Le site a reçu trop de demandes coup sur coup.\n\n'
        + 'Patientez une minute, puis réessayez.';
    }
    /* Shopify motive son refus dans « description » (article épuisé, etc.) */
    var d = body && (body.description || body.message);
    if (d) return d;
    return 'L\'ajout au panier a échoué (erreur ' + status + ').\n\nVeuillez réessayer.';
  }

  function postCartAdd(fd) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd,
    }).then(function (r) {
      return r.text().then(function (txt) {
        var body = null;
        try { body = JSON.parse(txt); } catch (e) {}
        if (!r.ok) {
          var err = new Error('cart');
          err.status = r.status;
          err.body = body;
          throw err;
        }
        return body;
      });
    }, function () {
      var err = new Error('network');
      err.status = 0;
      throw err;
    });
  }

  function addToCart() {
    if (!state.variantId) { alert('Erreur : aucun produit sélectionné.'); return; }
    if (!state.elements.length) {
      if (!confirm('Vous n\'avez ajouté aucune personnalisation. Ajouter quand même ?')) return;
    }
    var btn = document.getElementById('banco-add-to-cart');
    btn.disabled = true; btn.textContent = 'Préparation de votre photo…';
    setStepBar(3);

    function restoreBtn() {
      btn.textContent = 'Ajouter au panier';
      btn.style.background = ''; btn.disabled = false;
      setStepBar(2);
    }

    /* Envoi en multipart : Shopify stocke nativement les fichiers joints aux
       propriétés de ligne — l'atelier reçoit la PHOTO DU CLIENT en couleur, ni
       détourée ni convertie en noir & blanc, en lien direct dans la commande
       (seul son poids est ramené à la raison, voir prepareUploadFile), ET
       l'aperçu de la mise en page telle que le client l'a validée. */
    var files = state.elements.filter(function (e) { return e.type === 'image' && e._file; });

    /* saisi maintenant, à l'instant du clic : ce que le client voit est ce
       que l'atelier recevra */
    var apercuPromise = renderApercuBlob();

    Promise.all([apercuPromise, Promise.all(files.map(function (el) {
      return prepareUploadFile(el._file);
    }))])
      .then(function (res) {
        var apercu = res[0];
        var prepared = res[1];
        btn.textContent = 'Ajout en cours…';
        var fd = new FormData();
        fd.append('id', state.variantId);
        fd.append('quantity', 1);
        var props = buildProperties();
        Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
        prepared.forEach(function (blob, i) {
          if (!blob) return;
          var key = files.length > 1 ? 'Photo originale ' + (i + 1) : 'Photo originale';
          var src = files[i]._file.name || 'photo-client.jpg';
          var name = src.replace(/[^\w.\-]+/g, '_');
          /* ré-encodée en JPEG : l'extension doit suivre, sinon la commande
             porte un .png qui n'en est pas un */
          if (blob !== files[i]._file) name = name.replace(/\.[^.]*$/, '') + '.jpg';
          fd.append('properties[' + key + ']', blob, name);
        });
        /* en dernier, comme la fiche de montage qu'on pose sur la pile :
           l'atelier lit la photo d'origine, puis ce qu'il doit en faire.
           Le souligné en tête est la convention Shopify des propriétés
           privées : masquée du panier, du paiement et des e-mails du client,
           la pièce jointe reste attachée à la commande et lisible dans
           l'administration — c'est une fiche d'atelier, pas un document
           destiné au client. */
        if (apercu) {
          fd.append('properties[_Aperçu de la gravure]', apercu, 'apercu-gravure.jpg');
        }
        /* Les fragments de la confirmation du thème, demandés dans le même
           aller-retour — comme le fait le formulaire de la fiche produit.
           Sans eux, l'ajout se terminait sur un compteur qui monte et rien
           d'autre : aucune route vers le paiement, alors que TOUS les
           acheteurs de la boutique passent par ce configurateur. */
        var panier = panierDuTheme();
        if (panier && typeof panier.getSectionsToRender === 'function') {
          fd.append('sections', panier.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        return postCartAdd(fd).catch(function (err) {
          /* incident passager (limitation de débit, coupure réseau, erreur
             serveur) : une seule reprise, après une pause — réappuyer aussitôt
             ne faisait qu'aggraver la limitation */
          if (err.status && err.status !== 429 && err.status < 500) throw err;
          btn.textContent = 'Nouvelle tentative…';
          return delay(err.status === 429 ? 4000 : 1500).then(function () {
            return postCartAdd(fd);
          });
        });
      })
      .then(function (reponse) {
        btn.textContent = '✓ Ajouté !';
        btn.style.background = '#1F7A43';
        confirmerAjout(restoreBtn, reponse);
      })
      .catch(function (err) {
        console.error('[BANCO] Ajout au panier impossible :', err && err.status, err && err.body);
        alert(cartErrorMessage(err && err.status, err && err.body));
        restoreBtn();
      });
  }

  /* --- CONFIRMATION DE L'AJOUT -------------------------------------------
     Ce que le client voit quand sa gravure est prise — et le seul endroit qui
     décide de la fermeture du panneau.

       0 ms      le voile couvre le panneau, la coche se trace
       380 ms    l'aperçu s'envole vers l'icône du panier (vol : 720 ms)
       700 ms    le panneau se retire (300 ms), dégageant l'en-tête à temps
                 pour l'arrivée de l'article, à 1 100 ms
       1 060 ms  remise à neuf hors de vue : bouton, voile, étape

     La fermeture est un minuteur simple, tenu à l'écart des animations : ni le
     vol, ni le voile, ni le compteur du panier ne peuvent l'empêcher d'arriver.
     Rester ouvert sur une personnalisation déjà commandée n'offre plus rien à
     faire, et invite au double ajout.

     1 100 ms  la confirmation du thème s'ouvre — « Voir le panier » et
               « Procéder au paiement ». Elle arrive quand l'article se pose,
               et sur un panneau déjà refermé : c'est la seule route vers la
               caisse que voit un client venu du configurateur. */
  var AJOUT_VOL = 380;
  var AJOUT_FERMETURE = 700;
  var AJOUT_CONFIRMATION = 1100;

  /* La pastille du thème (réglage `cart_type = notification`) ou le tiroir. */
  function panierDuTheme() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function ouvrirConfirmationPanier(reponse) {
    var panier = panierDuTheme();
    if (!panier || typeof panier.renderContents !== 'function') return;
    if (!reponse || !reponse.sections) return;
    try {
      panier.renderContents(reponse);
    } catch (e) {
      /* un fragment manquant ne doit pas passer pour un échec : la gravure est
         au panier, seule la mise en scène a manqué */
      console.warn('[BANCO] Confirmation du panier non affichée :', e);
    }
  }

  function confirmerAjout(restoreBtn, reponse) {
    var veil = document.getElementById('banco-ajout-veil');
    /* le client a pu refermer le panneau à la main pendant l'envoi : plus rien
       à mettre en scène ici, mais le panier doit quand même l'accuser */
    var ouvert = modal.classList.contains('banco-open');
    var reduit = mouvementReduit();

    if (ouvert && veil) veil.classList.add('is-visible');

    setTimeout(volVersPanier, reduit ? 0 : AJOUT_VOL);

    setTimeout(function () {
      if (ouvert) closeModal();
      setTimeout(function () {
        if (veil) veil.classList.remove('is-visible');
        restoreBtn();
      }, 360);
    }, reduit ? 420 : AJOUT_FERMETURE);

    /* après la fermeture du panneau, sinon la confirmation s'ouvrirait
       derrière lui */
    setTimeout(function () {
      ouvrirConfirmationPanier(reponse);
    }, reduit ? 480 : AJOUT_CONFIRMATION);
  }

  /* C'est l'aperçu composé par le client qui part vers l'icône du panier — son
     article, pas une photo de catalogue. Mise en scène commune à tout le site :
     voir banco-ajout-panier.js. Sans ce fichier, le compteur est quand même
     remis à jour. */
  function volVersPanier() {
    if (window.BancoPanier && canvas) {
      window.BancoPanier.celebrer({
        image: canvas,
        rect: canvas.getBoundingClientRect()
      });
      return;
    }
    refreshCartCount();
  }

  function buildProperties() {
    var props = {};
    /* orientation choisie (uniquement pour les produits orientables) —
       l'atelier sait dans quel sens graver */
    if (state.selectedProduct && ROTATABLE_HANDLES.indexOf(state.selectedProduct.handle) !== -1) {
      props['Orientation du produit'] = state.productRotated ? 'Paysage' : 'Portrait';
    }
    /* présentation choisie — la variante la porte déjà, mais l'atelier lit
       cette liste, pas le titre de ligne */
    if (aPresentation(state.selectedProduct)) {
      props['Présentation'] = PRESENTATION_VARIANTES[presentationCle()];
    }
    var textEls = state.elements.filter(function (e) { return e.type === 'text'; });
    var imgEls  = state.elements.filter(function (e) { return e.type === 'image'; });
    var tc = 0, ic = 0;
    state.elements.forEach(function (el) {
      if (el.type === 'text') {
        tc++;
        var p = textEls.length > 1 ? 'Texte ' + tc + ' — ' : '';
        props[p + 'Texte gravé'] = el.text;
        props[p + 'Police'] = el.font.split(',')[0].replace(/"/g, '').trim();
        props[p + 'Taille'] = el.size + 'px';
        var s = []; if (el.bold) s.push('Gras'); if (el.italic) s.push('Italique');
        if (s.length) props[p + 'Style'] = s.join(', ');
        props[p + 'Position (x/y)'] = Math.round(el.x) + ' / ' + Math.round(el.y);
      } else if (el.type === 'image') {
        ic++;
        var pp = imgEls.length > 1 ? 'Photo ' + ic + ' — ' : '';
        props[pp + 'Photo personnalisée'] = 'Oui (fournie par le client)';
        /* choix du client dans le configurateur — l'atelier grave en conséquence */
        var parTrace = el._rapport && el._rapport.detourage === 'aplat';
        props[pp + 'Arrière-plan'] = el.bgRemoved
          ? (parTrace ? 'Retiré (découpe exacte du tracé)' : 'Retiré (détourage IA)')
          : 'Conservé (photo entière)';
        /* l'atelier sait d'emblée s'il reçoit un logo ou une photo, et si le
           détourage a été refusé — c'est là que sa retouche est attendue */
        if (el._rapport) props[pp + 'Type d\'image'] = parTrace ? 'Logo / dessin au trait' : 'Photographie';
        if (el._bgMotif) props[pp + 'À vérifier'] = el._bgMotif;
        props[pp + 'Taille photo'] = el.sizePercent + '%';
        if (el._engine) props[pp + 'Contraste gravure'] = Math.round(el._engine.params.contrast * 100) + '/80';
        if (el.rotation) props[pp + 'Rotation photo'] = el.rotation + '°';
        props[pp + 'Position photo (x/y)'] = Math.round(el.x) + ' / ' + Math.round(el.y);
      }
    });
    /* message libre du client — dernier de la liste, comme dans le
       configurateur, pour que l'atelier le lise après la fiche technique */
    var instructions = document.getElementById('banco-instructions');
    var notes = instructions ? instructions.value.trim() : '';
    if (notes) props['Instructions pour l\'atelier'] = notes;
    return props;
  }

  function updateInstructionsCount() {
    var instructions = document.getElementById('banco-instructions');
    var count = document.getElementById('banco-instructions-count');
    if (instructions && count) count.textContent = instructions.value.length;
  }

  function refreshCartCount() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          var nb = tmp.querySelector('.cart-count-bubble');
          var ob = document.querySelector('.cart-count-bubble');
          if (nb && ob) ob.innerHTML = nb.innerHTML;
        }
      })
      .catch(function () {});
  }

  // --- DRAG-DROP ZONE ---

  function initDropzone() {
    var dz = document.getElementById('banco-dropzone');
    if (!dz) return;

    dz.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dz.classList.add('drag-over');
    });

    dz.addEventListener('dragleave', function (e) {
      if (!dz.contains(e.relatedTarget)) dz.classList.remove('drag-over');
    });

    dz.addEventListener('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dz.classList.remove('drag-over');
      var files = e.dataTransfer && e.dataTransfer.files;
      if (files && files[0]) addImageAsync(files[0]);
    });

    dz.addEventListener('click', function (e) {
      if (e.target.tagName === 'LABEL' || e.target.tagName === 'INPUT') return;
      var inp = document.getElementById('banco-image-input');
      if (inp) inp.click();
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
